import React, { useState, useEffect, useContext, useRef } from 'react';
import emailjs from '@emailjs/browser';
import { ToastContext } from '../App';

const EJS_SERVICE  = 'service_15jxhy9';
const EJS_TEMPLATE = 'template_up6mhic';
const EJS_KEY      = 'NTdmsuvPdoVUFm-b2';
const ADMIN_USER   = 'admin';
const ADMIN_PASS   = 'rent355admin';

// ─── ICONS ────────────────────────────────────────────
const Ic = ({ d, size=18, stroke=1.8 }) => (
  <svg width={size} height={size} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={stroke}>
    <path strokeLinecap="round" strokeLinejoin="round" d={d}/>
  </svg>
);
const I = {
  dash:    "M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z",
  car:     "M8 17h.01M16 17h.01M3 10l2-6h14l2 6M3 10h18M3 10l-1 7h20l-1-7",
  fleet:   "M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0zM13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10l2.293.293A1 1 0 006 17h1m6-1V8a1 1 0 011-1h3.5a1 1 0 01.8.4l2.5 3.333A1 1 0 0121 11.333V16a1 1 0 01-1 1h-1m-6 0h-4",
  booking: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z",
  clients: "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z",
  maint:   "M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z M15 12a3 3 0 11-6 0 3 3 0 016 0z",
  docs:    "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z",
  fuel:    "M3 10h2m14 0h2M5 10V6a1 1 0 011-1h12a1 1 0 011 1v4M5 10l-1 9h16l-1-9M9 14v2m6-2v2",
  revenue: "M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z",
  warn:    "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z",
  check:   "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z",
  mail:    "M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z",
  plus:    "M12 4v16m8-8H4",
  edit:    "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z",
  trash:   "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16",
  close:   "M6 18L18 6M6 6l12 12",
  logout:  "M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1",
  eye:     "M15 12a3 3 0 11-6 0 3 3 0 016 0zM2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z",
  lock:    "M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z",
  search:  "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z",
  photo:   "M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z",
  up:      "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12",
};

// ─── STATUS CONFIGS ───────────────────────────────────
const VSTATUS = {
  available:      { label:'Available',      color:'#059669', bg:'#DCFCE7', border:'#86EFAC' },
  on_rent:        { label:'On Rent',         color:'#2563EB', bg:'#DBEAFE', border:'#93C5FD' },
  maintenance:    { label:'Maintenance',     color:'#D97706', bg:'#FEF3C7', border:'#FCD34D' },
  out_of_service: { label:'Out of Service',  color:'#DC2626', bg:'#FEE2E2', border:'#FCA5A5' },
};
const BSTATUS = {
  pending:   { color:'#D97706', bg:'#FEF3C7' },
  confirmed: { color:'#2563EB', bg:'#DBEAFE' },
  completed: { color:'#059669', bg:'#DCFCE7' },
  cancelled: { color:'#DC2626', bg:'#FEE2E2' },
};

// ─── STORAGE HELPERS ──────────────────────────────────
const LS = {
  get:  (k,fb=[]) => { try { return JSON.parse(localStorage.getItem(k)||'null') ?? fb; } catch { return fb; } },
  set:  (k,v) => localStorage.setItem(k, JSON.stringify(v)),
};

// ─── API + EXTRA FIELDS MERGER ────────────────────────
// Cars live in the API; extra fields (plate, VIN, docs, KM, fuel) in localStorage
const getFleetExtra = () => LS.get('r355_fleet_extra', {});
async function loadFleet() {
  const r = await fetch('/api/cars');
  const cars = await r.json();
  const extra = getFleetExtra();
  return cars.map(v => ({
    ...v,
    status: (extra[v.id]?.status) || (v.available ? 'available' : 'on_rent'),
    ...( extra[v.id] || {} )
  }));
}

// Hook for views that need fleet data
function useFleet() {
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);
  const reload = () => {
    setLoading(true);
    loadFleet().then(v => { setVehicles(v); setLoading(false); }).catch(()=>setLoading(false));
  };
  useEffect(() => { reload(); }, []);
  return { vehicles, loading, reload };
}



// ─── DATE HELPERS ─────────────────────────────────────
const daysUntil = d => d ? Math.ceil((new Date(d)-new Date())/86400000) : null;
const urgency = d => {
  const n = daysUntil(d);
  if (n===null) return { label:'Not set', color:'#9CA3AF', bg:'#F3F4F6' };
  if (n < 0)   return { label:`Overdue ${Math.abs(n)}d`, color:'#DC2626', bg:'#FEE2E2' };
  if (n === 0) return { label:'Due today!', color:'#DC2626', bg:'#FEE2E2' };
  if (n <= 14) return { label:`${n}d left`, color:'#D97706', bg:'#FEF3C7' };
  if (n <= 60) return { label:`${n}d left`, color:'#2563EB', bg:'#DBEAFE' };
  return { label:`${n}d left`, color:'#059669', bg:'#DCFCE7' };
};

// ─── EMPTY TEMPLATES ──────────────────────────────────
const EV = { vin:'',plate:'',name:'',brand:'',model:'',year:2024,color:'',category:'Economic',
  status:'available',image:'',seats:5,transmission:'Automatic',fuel:'Petrol',price:'',
  currentKm:0,fuelLevel:100,fuelType:'Petrol',lastServiceDate:'',lastServiceKm:'',
  nextServiceDate:'',nextServiceKm:'',oilChangeKm:'',tirePressure:'',
  taxAmount:'',taxDate:'',taxDueDate:'',inspectionDate:'',inspectionDueDate:'',
  insuranceExpiry:'',insuranceCompany:'',notes:'' };

// ─── SHARED STYLES ────────────────────────────────────
const inp = { width:'100%', padding:'10px 13px', background:'#F9FAFB', border:'1.5px solid #E5E7EB',
  borderRadius:9, color:'#111827', fontFamily:'var(--font-body)', fontSize:14, outline:'none', boxSizing:'border-box', transition:'border-color 0.15s' };
const lbl = { display:'block', fontSize:11, fontWeight:700, color:'#9CA3AF', letterSpacing:'0.07em', textTransform:'uppercase', marginBottom:6 };

// ─── BTN COMPONENTS ───────────────────────────────────
const PrimaryBtn = ({ onClick, children, style={} }) => (
  <button onClick={onClick} style={{ display:'inline-flex', alignItems:'center', gap:7, background:'var(--red)', color:'#fff', border:'none', borderRadius:10, padding:'10px 22px', fontSize:13, fontWeight:700, cursor:'pointer', fontFamily:'var(--font-body)', boxShadow:'0 4px 14px rgba(196,18,48,0.3)', transition:'all 0.2s', ...style }}
    onMouseEnter={e=>e.currentTarget.style.transform='translateY(-1px)'}
    onMouseLeave={e=>e.currentTarget.style.transform='translateY(0)'}>
    {children}
  </button>
);
const GhostBtn = ({ onClick, children, style={} }) => (
  <button onClick={onClick} style={{ display:'inline-flex', alignItems:'center', gap:7, background:'#fff', color:'#555', border:'1.5px solid #E5E7EB', borderRadius:9, padding:'9px 18px', fontSize:13, fontWeight:600, cursor:'pointer', fontFamily:'var(--font-body)', transition:'all 0.15s', ...style }}
    onMouseEnter={e=>{e.currentTarget.style.borderColor='var(--red)';e.currentTarget.style.color='var(--red)';}}
    onMouseLeave={e=>{e.currentTarget.style.borderColor='#E5E7EB';e.currentTarget.style.color='#555';}}>
    {children}
  </button>
);
const IconBtn = ({ icon, danger, onClick, title }) => (
  <button title={title} onClick={onClick} style={{ width:32, height:32, display:'flex', alignItems:'center', justifyContent:'center', border:'1px solid #F0F0F0', borderRadius:7, background:'#fff', color: danger?'#DC2626':'#777', cursor:'pointer', transition:'all 0.15s', flexShrink:0 }}
    onMouseEnter={e=>{e.currentTarget.style.background=danger?'#FEE2E2':'#F4F5F7';e.currentTarget.style.borderColor=danger?'#FCA5A5':'#DDD';}}
    onMouseLeave={e=>{e.currentTarget.style.background='#fff';e.currentTarget.style.borderColor='#F0F0F0';}}>
    <Ic d={icon} size={14}/>
  </button>
);

// ─── MODAL WRAPPER ────────────────────────────────────
const Modal = ({ onClose, children, wide }) => (
  <div onClick={onClose} style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.45)', backdropFilter:'blur(3px)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center', padding:20 }}>
    <div onClick={e=>e.stopPropagation()} style={{ background:'#fff', borderRadius:18, width:'100%', maxWidth: wide?820:520, boxShadow:'0 32px 80px rgba(0,0,0,0.18)', maxHeight:'90vh', display:'flex', flexDirection:'column', overflow:'hidden' }}>
      {children}
    </div>
  </div>
);

// ─── STATUS BADGE ────────────────────────────────────
const SBadge = ({ status, map=BSTATUS }) => {
  const s = map[status] || { color:'#888', bg:'#F4F5F7' };
  return <span style={{ background:s.bg, color:s.color, borderRadius:20, padding:'3px 11px', fontSize:11, fontWeight:700, textTransform:'capitalize', whiteSpace:'nowrap' }}>{status?.replace('_',' ')||'—'}</span>;
};

// ─── IMAGE UPLOADER ───────────────────────────────────
function ImageUploader({ value, onChange }) {
  const ref = useRef();
  const handle = e => {
    const f = e.target.files[0]; if(!f) return;
    const r = new FileReader();
    r.onload = ev => {
      const img = new Image();
      img.onload = () => {
        const MAX = 800;
        const scale = Math.min(1, MAX / Math.max(img.width, img.height));
        const canvas = document.createElement('canvas');
        canvas.width  = Math.round(img.width  * scale);
        canvas.height = Math.round(img.height * scale);
        canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
        onChange(canvas.toDataURL('image/jpeg', 0.82));
      };
      img.src = ev.target.result;
    };
    r.readAsDataURL(f);
  };
  if (value) return (
    <div style={{ position:'relative', borderRadius:12, overflow:'hidden', border:'2px solid #E5E7EB' }}>
      <img src={value} alt="" style={{ width:'100%', height:160, objectFit:'cover', display:'block' }}/>
      <button onClick={()=>onChange('')} style={{ position:'absolute', top:8, right:8, background:'rgba(0,0,0,0.55)', color:'#fff', border:'none', borderRadius:6, width:28, height:28, display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer' }}><Ic d={I.close} size={12}/></button>
    </div>
  );
  return (
    <div onClick={()=>ref.current.click()} style={{ border:'2px dashed #E5E7EB', borderRadius:12, padding:'28px', textAlign:'center', cursor:'pointer', transition:'all 0.15s', background:'#F9FAFB' }}
      onMouseEnter={e=>{e.currentTarget.style.borderColor='var(--red)';e.currentTarget.style.background='#FFF5F6';}}
      onMouseLeave={e=>{e.currentTarget.style.borderColor='#E5E7EB';e.currentTarget.style.background='#F9FAFB';}}>
      <input ref={ref} type="file" accept="image/*" style={{display:'none'}} onChange={handle}/>
      <div style={{ color:'#CBD5E1', marginBottom:8 }}><Ic d={I.photo} size={28}/></div>
      <div style={{ fontSize:13, fontWeight:600, color:'#9CA3AF' }}>Click or drag photo</div>
      <div style={{ fontSize:11, color:'#D1D5DB', marginTop:3 }}>JPG, PNG, WEBP</div>
    </div>
  );
}

// ══════════════════════════════════════════════════════
// MAIN ADMIN COMPONENT
// ══════════════════════════════════════════════════════
export default function Admin() {
  const [authed, setAuthed] = useState(() => sessionStorage.getItem('r355_admin')==='true');
  const [view,   setView]   = useState('dashboard');
  const showToast = useContext(ToastContext);
  if (!authed) return <LoginScreen onLogin={() => { sessionStorage.setItem('r355_admin','true'); setAuthed(true); }}/>;
  const handleLogout = () => { sessionStorage.removeItem('r355_admin'); setAuthed(false); };

  const NAV = [
    { key:'dashboard', label:'Dashboard',      icon:I.dash    },
    { key:'fleet',     label:'Fleet',          icon:I.fleet   },
    { key:'bookings',  label:'Reservations',   icon:I.booking },
    { key:'clients',   label:'CRM',            icon:I.clients },
    { key:'maint',     label:'Maintenance',    icon:I.maint   },
    { key:'docs',      label:'Documents',      icon:I.docs    },
    { key:'calendar',  label:'Rental Calendar', icon:I.booking },
    { key:'analytics', label:'Analytics',      icon:I.revenue },
  ];

  return (
    <div style={{ display:'flex', minHeight:'calc(100vh - 64px)', background:'#F8F9FB', fontFamily:'var(--font-body)' }}>
      {/* ── SIDEBAR ── */}
      <aside style={{ width:230, background:'#0C0C0C', display:'flex', flexDirection:'column', flexShrink:0 }}>
        <div style={{ padding:'22px 18px', borderBottom:'1px solid rgba(255,255,255,0.07)' }}>
          <div style={{ display:'flex', alignItems:'center', gap:10 }}>
            <div style={{ width:36, height:36, background:'var(--red)', borderRadius:9, display:'flex', alignItems:'center', justifyContent:'center', color:'#fff', flexShrink:0 }}>
              <Ic d={I.fleet} size={16}/>
            </div>
            <div>
              <div style={{ fontSize:13, fontWeight:800, color:'#fff', letterSpacing:'0.04em' }}>RENT355</div>
              <div style={{ fontSize:10, color:'rgba(255,255,255,0.4)', fontWeight:600, letterSpacing:'0.06em' }}>MANAGEMENT SYSTEM</div>
            </div>
          </div>
        </div>
        <nav style={{ flex:1, padding:'12px 10px' }}>
          {NAV.map(item => (
            <button key={item.key} onClick={()=>setView(item.key)} style={{
              width:'100%', display:'flex', alignItems:'center', gap:10, padding:'10px 12px', borderRadius:8,
              border:'none',
              outline: view===item.key ? '0' : '0',
              background: view===item.key ? 'rgba(196,18,48,0.18)' : 'transparent',
              color: view===item.key ? '#FFFFFF' : '#AAAAAA',
              WebkitTextFillColor: view===item.key ? '#FFFFFF' : '#AAAAAA',
              fontSize:13, fontWeight: view===item.key ? 700 : 500, cursor:'pointer',
              fontFamily:'var(--font-body)', transition:'all 0.15s', marginBottom:2,
              borderLeft: view===item.key ? '3px solid #C41230' : '3px solid transparent',
              textAlign:'left',
            }}
              onMouseEnter={e=>{ if(view!==item.key){ e.currentTarget.style.color='#FFFFFF'; e.currentTarget.style.WebkitTextFillColor='#FFFFFF'; e.currentTarget.style.background='rgba(255,255,255,0.07)'; }}}
              onMouseLeave={e=>{ if(view!==item.key){ e.currentTarget.style.color='#AAAAAA'; e.currentTarget.style.WebkitTextFillColor='#AAAAAA'; e.currentTarget.style.background='transparent'; }}}>
              <Ic d={item.icon} size={15}/> {item.label}
            </button>
          ))}
        </nav>
        <div style={{ padding:'12px 10px', borderTop:'1px solid rgba(255,255,255,0.07)' }}>
          <button onClick={handleLogout} style={{ width:'100%', display:'flex', alignItems:'center', gap:10, padding:'10px 12px', borderRadius:8, border:'none', background:'none', color:'rgba(255,255,255,0.3)', fontSize:13, fontWeight:500, cursor:'pointer', fontFamily:'var(--font-body)', transition:'all 0.15s' }}
            onMouseEnter={e=>{ e.currentTarget.style.color='#fff'; e.currentTarget.style.background='rgba(196,18,48,0.2)'; }}
            onMouseLeave={e=>{ e.currentTarget.style.color='rgba(255,255,255,0.3)'; e.currentTarget.style.background='none'; }}>
            <Ic d={I.logout} size={15}/> Sign Out
          </button>
        </div>
      </aside>

      {/* ── CONTENT ── */}
      <main style={{ flex:1, overflow:'auto', padding:'32px' }}>
        {view==='dashboard'  && <DashboardView   setView={setView} showToast={showToast}/>}
        {view==='fleet'      && <FleetView        showToast={showToast}/>}
        {view==='bookings'   && <ReservationsView showToast={showToast}/>}
        {view==='clients'    && <CRMView          showToast={showToast}/>}
        {view==='maint'      && <MaintenanceView  showToast={showToast}/>}
        {view==='docs'       && <DocumentsView    showToast={showToast}/>}
        {view==='calendar'   && <CalendarView   showToast={showToast}/>}
        {view==='analytics'  && <AnalyticsView/>}
      </main>
    </div>
  );
}

// ══════════════════════════════════════════════════════
// LOGIN
// ══════════════════════════════════════════════════════
function LoginScreen({ onLogin }) {
  const [u,setU]=useState(''); const [p,setP]=useState(''); const [err,setErr]=useState(''); const [loading,setLoading]=useState(false); const [show,setShow]=useState(false);
  const submit = () => {
    setLoading(true); setErr('');
    setTimeout(()=>{ if(u===ADMIN_USER&&p===ADMIN_PASS){onLogin();}else{setErr('Invalid credentials.');setLoading(false);} },700);
  };
  return (
    <div style={{ minHeight:'calc(100vh - 64px)', display:'flex', alignItems:'center', justifyContent:'center', background:'#0C0C0C', padding:20 }}>
      <div style={{ background:'#161616', borderRadius:20, padding:'48px 44px', width:'100%', maxWidth:420, border:'1px solid rgba(255,255,255,0.08)', boxShadow:'0 40px 80px rgba(0,0,0,0.5)' }}>
        <div style={{ textAlign:'center', marginBottom:36 }}>
          <div style={{ width:64, height:64, background:'var(--red)', borderRadius:16, display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 16px', boxShadow:'0 8px 24px rgba(196,18,48,0.4)' }}>
            <Ic d={I.lock} size={26}/>
          </div>
          <div style={{ fontFamily:'var(--font-display)', fontSize:28, color:'#fff', letterSpacing:'0.06em' }}>RENT355</div>
          <div style={{ fontSize:13, color:'rgba(255,255,255,0.4)', marginTop:4 }}>Management System</div>
        </div>
        {err && <div style={{ background:'#FEE2E2', color:'#DC2626', borderRadius:9, padding:'10px 14px', fontSize:13, fontWeight:600, marginBottom:16, textAlign:'center' }}>{err}</div>}
        <div style={{ marginBottom:14 }}>
          <div style={{ fontSize:11, fontWeight:700, color:'rgba(255,255,255,0.4)', letterSpacing:'0.08em', textTransform:'uppercase', marginBottom:6 }}>Username</div>
          <input value={u} onChange={e=>setU(e.target.value)} onKeyDown={e=>e.key==='Enter'&&submit()} style={{ ...inp, background:'rgba(255,255,255,0.06)', border:'1.5px solid rgba(255,255,255,0.1)', color:'#fff' }} placeholder="admin"/>
        </div>
        <div style={{ marginBottom:24 }}>
          <div style={{ fontSize:11, fontWeight:700, color:'rgba(255,255,255,0.4)', letterSpacing:'0.08em', textTransform:'uppercase', marginBottom:6 }}>Password</div>
          <div style={{ position:'relative' }}>
            <input value={p} onChange={e=>setP(e.target.value)} onKeyDown={e=>e.key==='Enter'&&submit()} type={show?'text':'password'} style={{ ...inp, background:'rgba(255,255,255,0.06)', border:'1.5px solid rgba(255,255,255,0.1)', color:'#fff', paddingRight:44 }} placeholder="••••••••"/>
            <button onClick={()=>setShow(!show)} style={{ position:'absolute', right:12, top:'50%', transform:'translateY(-50%)', background:'none', border:'none', color:'rgba(255,255,255,0.4)', cursor:'pointer', padding:0 }}><Ic d={I.eye} size={16}/></button>
          </div>
        </div>
        <button onClick={submit} disabled={loading} style={{ width:'100%', padding:'13px', background:'var(--red)', color:'#fff', border:'none', borderRadius:10, fontSize:14, fontWeight:700, cursor:'pointer', fontFamily:'var(--font-body)', boxShadow:'0 4px 20px rgba(196,18,48,0.4)', transition:'all 0.2s' }}>
          {loading ? 'Signing in…' : 'Sign In →'}
        </button>
      </div>
    </div>
  );
}

// ══════════════════════════════════════════════════════
// DASHBOARD
// ══════════════════════════════════════════════════════
function DashboardView({ setView, showToast }) {
  const { vehicles } = useFleet();
  const [bookings, setBookings] = useState([]);
  const [loading,  setLoading]  = useState(true);

  useEffect(() => {
    fetch('/api/bookings')
      .then(r => r.json())
      .then(b => { setBookings(b); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  // Pull calendar rentals from localStorage
  const calRentals = LS.get('r355_calendar_v1', []);

  const todayIso = (() => {
    const d = new Date();
    const y = d.getFullYear(), m = String(d.getMonth()+1).padStart(2,'0'), day = String(d.getDate()).padStart(2,'0');
    return `${y}-${m}-${day}`;
  })();

  // KPIs
  const totalRevenue   = bookings.filter(b => b.status === 'completed').reduce((s,b) => s + (b.totalPrice||0), 0);
  const calRevenue     = calRentals.reduce((s,r) => s + (Number(r.totalPrice)||0), 0);
  const activeRentals  = bookings.filter(b => b.status === 'confirmed').length;
  const calActive      = calRentals.filter(r => r.startDate <= todayIso && r.endDate >= todayIso).length;
  const available      = vehicles.filter(v => v.status === 'available'  || v.available).length;
  const onRent         = vehicles.filter(v => v.status === 'on_rent'    || (!v.available && v.status !== 'maintenance' && v.status !== 'out_of_service')).length;
  const inMaint        = vehicles.filter(v => v.status === 'maintenance').length;
  const unpaidCal      = calRentals.filter(r => r.payStatus === 'unpaid' || r.payStatus === 'partial').length;

  // Today pickups & returns from calendar
  const todayPickups  = calRentals.filter(r => r.startDate === todayIso);
  const todayReturns  = calRentals.filter(r => r.endDate   === todayIso);

  // Overdue returns
  const overdue = calRentals.filter(r => r.endDate < todayIso && r.startDate <= todayIso);

  // Document alerts
  const docAlerts = vehicles.flatMap(v => [
    { v, label:'Road Tax',   date: v.taxDueDate },
    { v, label:'Inspection', date: v.inspectionDueDate },
    { v, label:'Insurance',  date: v.insuranceExpiry },
  ]).filter(a => a.date && daysUntil(a.date) <= 30)
    .sort((a,b) => daysUntil(a.date) - daysUntil(b.date));

  // This month revenue from calendar
  const thisMonth = calRentals.filter(r => r.startDate && r.startDate.slice(0,7) === todayIso.slice(0,7));
  const monthRev  = thisMonth.reduce((s,r) => s + (Number(r.totalPrice)||0), 0);

  const KPIS = [
    { label:'Available',      value: available,                         icon: I.car,     color:'#059669', bg:'#DCFCE7', sub:`of ${vehicles.length} cars` },
    { label:'On Rent Today',  value: calActive + activeRentals,         icon: I.fleet,   color:'#2563EB', bg:'#DBEAFE', sub:'active rentals' },
    { label:'Month Revenue',  value: `€${monthRev.toLocaleString()}`,   icon: I.revenue, color:'#C41230', bg:'#FEF0F2', sub:`${thisMonth.length} rentals` },
    { label:'Unpaid / Partial', value: unpaidCal,                       icon: I.warn,    color:'#D97706', bg:'#FEF3C7', sub:'need collection' },
  ];

  const carName = r => {
    const v = vehicles.find(x => String(x.id) === String(r.carId));
    const extra = LS.get('r355_fleet_extra', {})[r.carId] || {};
    const plate = extra.plate || v?.plate || '';
    return v ? `${v.name}${plate ? ` [${plate}]` : ''}` : 'Unknown car';
  };

  const SRC_LABEL = { website:'Website', agency:'Agency', walkin:'Walk-in', phone:'Phone', returning:'Returning', other:'Other' };

  return (
    <div>
      {/* Header */}
      <div style={{ marginBottom:24, display:'flex', justifyContent:'space-between', alignItems:'flex-end', flexWrap:'wrap', gap:12 }}>
        <div>
          <div style={{ fontFamily:'var(--font-display)', fontSize:36, letterSpacing:'0.04em', color:'#111827', lineHeight:1 }}>
            Good day, Eno 👋
          </div>
          <div style={{ fontSize:14, color:'#9CA3AF', marginTop:5 }}>
            {new Date().toLocaleDateString('en-GB', { weekday:'long', day:'numeric', month:'long', year:'numeric' })}
          </div>
        </div>
        <div style={{ display:'flex', gap:8 }}>
          <GhostBtn onClick={() => setView('calendar')}><Ic d={I.booking} size={13}/> Open Calendar</GhostBtn>
          <PrimaryBtn onClick={() => setView('fleet')}><Ic d={I.plus} size={13}/> Add Vehicle</PrimaryBtn>
        </div>
      </div>

      {/* KPIs */}
      <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:14, marginBottom:22 }}>
        {KPIS.map((k,i) => (
          <div key={i} style={{ background:'#fff', borderRadius:14, padding:'20px', border:'1px solid #F3F4F6', boxShadow:'0 1px 4px rgba(0,0,0,0.04)', transition:'all 0.2s' }}
            onMouseEnter={e => e.currentTarget.style.boxShadow='0 8px 24px rgba(0,0,0,0.08)'}
            onMouseLeave={e => e.currentTarget.style.boxShadow='0 1px 4px rgba(0,0,0,0.04)'}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:12 }}>
              <div style={{ width:38, height:38, background:k.bg, borderRadius:10, display:'flex', alignItems:'center', justifyContent:'center', color:k.color }}>
                <Ic d={k.icon} size={17}/>
              </div>
            </div>
            <div style={{ fontFamily:'var(--font-display)', fontSize:30, color:'#111827', letterSpacing:'0.03em', lineHeight:1, marginBottom:4 }}>{k.value}</div>
            <div style={{ fontSize:12, fontWeight:700, color:'#111827', marginBottom:2 }}>{k.label}</div>
            <div style={{ fontSize:11, color:'#9CA3AF' }}>{k.sub}</div>
          </div>
        ))}
      </div>

      {/* Fleet live board */}
      <div style={{ background:'#fff', borderRadius:14, border:'1px solid #F3F4F6', marginBottom:18, overflow:'hidden', boxShadow:'0 1px 4px rgba(0,0,0,0.04)' }}>
        <div style={{ padding:'16px 20px', borderBottom:'1px solid #F9FAFB', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <div style={{ fontSize:15, fontWeight:700, color:'#111827' }}>🚗 Live Fleet Board</div>
          <button onClick={() => setView('fleet')} style={{ fontSize:12, color:'var(--red)', fontWeight:600, background:'none', border:'none', cursor:'pointer', fontFamily:'var(--font-body)' }}>Manage Fleet →</button>
        </div>
        <div style={{ padding:16 }}>
          {vehicles.length === 0 ? (
            <div style={{ textAlign:'center', color:'#CBD5E1', padding:24, fontSize:13 }}>No vehicles yet. Add cars in Fleet.</div>
          ) : (
            <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(200px, 1fr))', gap:10 }}>
              {vehicles.map(v => {
                const extra = LS.get('r355_fleet_extra', {})[v.id] || {};
                const status = extra.status || (v.available ? 'available' : 'on_rent');
                const s = VSTATUS[status] || VSTATUS.available;
                const activeRental = calRentals.find(r => String(r.carId) === String(v.id) && r.startDate <= todayIso && r.endDate >= todayIso);
                return (
                  <div key={v.id} style={{ background: s.bg, border:`1.5px solid ${s.border}`, borderRadius:12, padding:'12px 14px', cursor:'pointer', transition:'all 0.15s' }}
                    onClick={() => setView('fleet')}
                    onMouseEnter={e => e.currentTarget.style.transform='translateY(-2px)'}
                    onMouseLeave={e => e.currentTarget.style.transform='translateY(0)'}>
                    <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:8 }}>
                      {v.image
                        ? <img src={v.image} alt="" style={{ width:52, height:34, objectFit:'cover', borderRadius:6, flexShrink:0 }}/>
                        : <div style={{ width:52, height:34, background:'rgba(0,0,0,0.06)', borderRadius:6, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}><Ic d={I.car} size={16}/></div>
                      }
                      <span style={{ background:s.color, color:'#fff', borderRadius:20, padding:'2px 8px', fontSize:9, fontWeight:800, letterSpacing:'0.06em', textTransform:'uppercase' }}>{s.label}</span>
                    </div>
                    <div style={{ fontSize:12, fontWeight:700, color:'#111827', marginBottom:2 }}>{v.name}</div>
                    {extra.plate && <div style={{ fontSize:10, color:'#6B7280', fontFamily:'monospace', marginBottom:4 }}>{extra.plate}</div>}
                    {activeRental && (
                      <div style={{ fontSize:10, color:s.color, fontWeight:600, marginTop:4, borderTop:`1px solid ${s.border}`, paddingTop:4 }}>
                        {activeRental.clientName} → {activeRental.endDate}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>

      {/* Today row */}
      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16, marginBottom:18 }}>

        {/* Today's Pickups */}
        <div style={{ background:'#fff', borderRadius:14, border:'1px solid #F3F4F6', overflow:'hidden', boxShadow:'0 1px 4px rgba(0,0,0,0.04)' }}>
          <div style={{ padding:'14px 18px', borderBottom:'1px solid #F9FAFB', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
            <div style={{ fontSize:14, fontWeight:700, color:'#111827' }}>📦 Today's Pickups</div>
            <span style={{ background:'#DCFCE7', color:'#059669', borderRadius:20, padding:'2px 10px', fontSize:11, fontWeight:700 }}>{todayPickups.length}</span>
          </div>
          {todayPickups.length === 0
            ? <div style={{ padding:'24px 18px', textAlign:'center', color:'#CBD5E1', fontSize:13 }}>No pickups today</div>
            : todayPickups.map(r => (
              <div key={r.id} style={{ padding:'12px 18px', borderBottom:'1px solid #F9FAFB', display:'flex', justifyContent:'space-between', alignItems:'center' }}
                onMouseEnter={e => e.currentTarget.style.background='#F9FAFB'}
                onMouseLeave={e => e.currentTarget.style.background=''}>
                <div>
                  <div style={{ fontSize:13, fontWeight:700, color:'#111827' }}>{r.clientName}</div>
                  <div style={{ fontSize:11, color:'#9CA3AF' }}>{carName(r)}</div>
                  {r.clientPhone && <div style={{ fontSize:11, color:'#6B7280' }}>{r.clientPhone}</div>}
                </div>
                <div style={{ textAlign:'right' }}>
                  <div style={{ fontSize:13, fontWeight:700, color:'var(--red)', fontFamily:'var(--font-display)' }}>€{r.totalPrice||0}</div>
                  <div style={{ fontSize:10, fontWeight:700, color: r.payStatus==='paid'?'#059669':r.payStatus==='partial'?'#D97706':'#DC2626' }}>
                    {r.payStatus==='paid'?'Paid':r.payStatus==='partial'?'Partial':'Unpaid'}
                  </div>
                </div>
              </div>
            ))
          }
        </div>

        {/* Today's Returns */}
        <div style={{ background:'#fff', borderRadius:14, border:'1px solid #F3F4F6', overflow:'hidden', boxShadow:'0 1px 4px rgba(0,0,0,0.04)' }}>
          <div style={{ padding:'14px 18px', borderBottom:'1px solid #F9FAFB', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
            <div style={{ fontSize:14, fontWeight:700, color:'#111827' }}>🔄 Today's Returns</div>
            <span style={{ background:'#DBEAFE', color:'#2563EB', borderRadius:20, padding:'2px 10px', fontSize:11, fontWeight:700 }}>{todayReturns.length}</span>
          </div>
          {todayReturns.length === 0
            ? <div style={{ padding:'24px 18px', textAlign:'center', color:'#CBD5E1', fontSize:13 }}>No returns today</div>
            : todayReturns.map(r => (
              <div key={r.id} style={{ padding:'12px 18px', borderBottom:'1px solid #F9FAFB', display:'flex', justifyContent:'space-between', alignItems:'center' }}
                onMouseEnter={e => e.currentTarget.style.background='#F9FAFB'}
                onMouseLeave={e => e.currentTarget.style.background=''}>
                <div>
                  <div style={{ fontSize:13, fontWeight:700, color:'#111827' }}>{r.clientName}</div>
                  <div style={{ fontSize:11, color:'#9CA3AF' }}>{carName(r)}</div>
                  <div style={{ fontSize:11, color:'#6B7280' }}>Since {r.startDate}</div>
                </div>
                <div style={{ textAlign:'right' }}>
                  <div style={{ fontSize:13, fontWeight:700, color:'var(--red)', fontFamily:'var(--font-display)' }}>€{r.totalPrice||0}</div>
                  <div style={{ fontSize:10, fontWeight:700, color: r.payStatus==='paid'?'#059669':r.payStatus==='partial'?'#D97706':'#DC2626' }}>
                    {r.payStatus==='paid'?'Paid':r.payStatus==='partial'?'Partial':'Unpaid'}
                  </div>
                </div>
              </div>
            ))
          }
        </div>
      </div>

      {/* Bottom row */}
      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16 }}>

        {/* Overdue returns */}
        <div style={{ background:'#fff', borderRadius:14, border:`1.5px solid ${overdue.length>0?'#FCA5A5':'#F3F4F6'}`, overflow:'hidden', boxShadow:'0 1px 4px rgba(0,0,0,0.04)' }}>
          <div style={{ padding:'14px 18px', borderBottom:'1px solid #F9FAFB', display:'flex', justifyContent:'space-between', alignItems:'center', background: overdue.length>0?'#FFF5F5':'#fff' }}>
            <div style={{ fontSize:14, fontWeight:700, color: overdue.length>0?'#DC2626':'#111827' }}>⚠️ Overdue Returns</div>
            <span style={{ background: overdue.length>0?'#FEE2E2':'#F3F4F6', color: overdue.length>0?'#DC2626':'#9CA3AF', borderRadius:20, padding:'2px 10px', fontSize:11, fontWeight:700 }}>{overdue.length}</span>
          </div>
          {overdue.length === 0
            ? <div style={{ padding:'24px 18px', textAlign:'center', color:'#CBD5E1', fontSize:13 }}>✅ No overdue returns</div>
            : overdue.map(r => {
              const daysOver = Math.ceil((new Date(todayIso) - new Date(r.endDate+'T00:00:00')) / 86400000);
              return (
                <div key={r.id} style={{ padding:'12px 18px', borderBottom:'1px solid #FEE2E2', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                  <div>
                    <div style={{ fontSize:13, fontWeight:700, color:'#111827' }}>{r.clientName}</div>
                    <div style={{ fontSize:11, color:'#9CA3AF' }}>{carName(r)}</div>
                    {r.clientPhone && <div style={{ fontSize:11, color:'#6B7280' }}>{r.clientPhone}</div>}
                  </div>
                  <span style={{ background:'#FEE2E2', color:'#DC2626', borderRadius:20, padding:'3px 10px', fontSize:11, fontWeight:800 }}>
                    {daysOver}d overdue
                  </span>
                </div>
              );
            })
          }
        </div>

        {/* Document alerts */}
        <div style={{ background:'#fff', borderRadius:14, border:`1.5px solid ${docAlerts.length>0?'#FCD34D':'#F3F4F6'}`, overflow:'hidden', boxShadow:'0 1px 4px rgba(0,0,0,0.04)' }}>
          <div style={{ padding:'14px 18px', borderBottom:'1px solid #F9FAFB', display:'flex', justifyContent:'space-between', alignItems:'center', background: docAlerts.length>0?'#FFFBEB':'#fff' }}>
            <div style={{ fontSize:14, fontWeight:700, color: docAlerts.length>0?'#D97706':'#111827' }}>📋 Document Alerts</div>
            <span style={{ background: docAlerts.length>0?'#FEF3C7':'#F3F4F6', color: docAlerts.length>0?'#D97706':'#9CA3AF', borderRadius:20, padding:'2px 10px', fontSize:11, fontWeight:700 }}>{docAlerts.length}</span>
          </div>
          {docAlerts.length === 0
            ? <div style={{ padding:'24px 18px', textAlign:'center', color:'#CBD5E1', fontSize:13 }}>✅ All documents valid</div>
            : docAlerts.slice(0,6).map((a,i) => {
              const u = urgency(a.date);
              return (
                <div key={i} style={{ padding:'10px 18px', borderBottom:'1px solid #F9FAFB', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                  <div>
                    <div style={{ fontSize:12, fontWeight:700, color:'#111827' }}>{a.v.name || a.v.plate}</div>
                    <div style={{ fontSize:11, color:'#9CA3AF' }}>{a.label} · {a.date}</div>
                  </div>
                  <span style={{ background:u.bg, color:u.color, borderRadius:20, padding:'3px 10px', fontSize:11, fontWeight:700 }}>{u.label}</span>
                </div>
              );
            })
          }
          {docAlerts.length > 6 && (
            <div style={{ padding:'10px 18px', textAlign:'center' }}>
              <button onClick={() => setView('docs')} style={{ fontSize:12, color:'var(--red)', fontWeight:600, background:'none', border:'none', cursor:'pointer', fontFamily:'var(--font-body)' }}>
                View all {docAlerts.length} alerts →
              </button>
            </div>
          )}
        </div>

      </div>
    </div>
  );
}


// ══════════════════════════════════════════════════════
// FLEET VIEW  (API-backed)
// ══════════════════════════════════════════════════════
function FleetView({ showToast }) {
  const [vehicles, setVehicles] = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [modal,    setModal]    = useState(null);
  const [detail,   setDetail]   = useState(null);
  const [search,   setSearch]   = useState('');
  const [sf,       setSf]       = useState('all');

  const load = () => {
    setLoading(true);
    fetch('/api/cars')
      .then(r => r.json())
      .then(data => {
        // Merge with any extra fleet fields stored in localStorage
        const extra = LS.get('r355_fleet_extra', {});
        const merged = data.map(v => ({ ...v, status: v.available ? 'available' : 'on_rent', ...( extra[v.id] || {} ) }));
        setVehicles(merged);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  // Persist extra fleet fields (status, vin, plate, km, fuel, docs etc.) to localStorage
  const saveExtra = (id, fields) => {
    const extra = LS.get('r355_fleet_extra', {});
    extra[id] = { ...(extra[id]||{}), ...fields };
    LS.set('r355_fleet_extra', extra);
  };

  const save = async (v) => {
    const isNew = !v.id;
    const body = {
      name: v.name, category: v.category, price: Number(v.price)||0,
      seats: Number(v.seats)||5, transmission: v.transmission||'Automatic',
      fuel: v.fuel||'Petrol', year: Number(v.year)||2024,
      available: v.status === 'available', image: v.image||'',
      mileage: v.currentKm ? `${Number(v.currentKm).toLocaleString()} km` : (v.mileage||'0 km'),
    };
    try {
      let saved;
      if (isNew) {
        const r = await fetch('/api/cars', { method:'POST', headers:{'Content-Type':'application/json','x-admin-key':'rent355admin'}, body:JSON.stringify(body) });
        saved = await r.json();
      } else {
        const r = await fetch(`/api/cars/${v.id}`, { method:'PUT', headers:{'Content-Type':'application/json','x-admin-key':'rent355admin'}, body:JSON.stringify(body) });
        saved = await r.json();
      }
      // Save extra fields to localStorage
      saveExtra(saved.id, { vin:v.vin, plate:v.plate, color:v.color, status:v.status||'available',
        currentKm:v.currentKm, fuelLevel:v.fuelLevel, fuelType:v.fuelType,
        lastServiceDate:v.lastServiceDate, lastServiceKm:v.lastServiceKm,
        nextServiceDate:v.nextServiceDate, nextServiceKm:v.nextServiceKm,
        oilChangeKm:v.oilChangeKm, tirePressure:v.tirePressure,
        taxAmount:v.taxAmount, taxDate:v.taxDate, taxDueDate:v.taxDueDate,
        inspectionDate:v.inspectionDate, inspectionDueDate:v.inspectionDueDate,
        insuranceExpiry:v.insuranceExpiry, insuranceCompany:v.insuranceCompany, notes:v.notes });
      await load();
      setModal(null);
      showToast(`${v.name||v.plate} saved ✅`);
    } catch(e) { showToast('❌ Save failed'); }
  };

  const del = async (id, n) => {
    if (!window.confirm(`Remove "${n}"?`)) return;
    await fetch(`/api/cars/${id}`, { method:'DELETE', headers:{'x-admin-key':'rent355admin'} });
    const extra = LS.get('r355_fleet_extra', {});
    delete extra[id]; LS.set('r355_fleet_extra', extra);
    setDetail(null);
    load();
  };

  const setVS = (id, status) => {
    const available = status === 'available';
    fetch(`/api/cars/${id}`, { method:'PUT', headers:{'Content-Type':'application/json','x-admin-key':'rent355admin'}, body:JSON.stringify({ available }) });
    saveExtra(id, { status });
    const u = vehicles.map(x => x.id===id ? {...x, status, available} : x);
    setVehicles(u);
    if (detail?.id===id) setDetail(u.find(x=>x.id===id));
  };

  const list = vehicles.filter(v =>
    (`${v.name}${v.plate||''}${v.vin||''}${v.category}`).toLowerCase().includes(search.toLowerCase()) &&
    (sf==='all' || v.status===sf)
  );

  return (
    <div>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24 }}>
        <div>
          <div style={{ fontFamily:'var(--font-display)', fontSize:32, letterSpacing:'0.04em', color:'#111827', lineHeight:1 }}>Fleet Management</div>
          <div style={{ fontSize:13, color:'#9CA3AF', marginTop:3 }}>{vehicles.length} vehicles registered</div>
        </div>
        <PrimaryBtn onClick={()=>setModal({...EV})}><Ic d={I.plus} size={14}/> Add Vehicle</PrimaryBtn>
      </div>

      <div style={{ display:'flex', gap:10, marginBottom:18, flexWrap:'wrap', alignItems:'center' }}>
        <div style={{ position:'relative', flex:1, minWidth:220 }}>
          <div style={{ position:'absolute', left:12, top:'50%', transform:'translateY(-50%)', color:'#CBD5E1' }}><Ic d={I.search} size={14}/></div>
          <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search name, category…" style={{ ...inp, paddingLeft:36 }}/>
        </div>
        {[['all','All'],['available','Available'],['on_rent','On Rent'],['maintenance','Maintenance'],['out_of_service','Out of Service']].map(([k,l])=>(
          <button key={k} onClick={()=>setSf(k)} style={{ padding:'9px 16px', borderRadius:20, fontSize:12, fontWeight:600, border:'1.5px solid', cursor:'pointer', fontFamily:'var(--font-body)', transition:'all 0.15s', background:sf===k?(VSTATUS[k]?.bg||'#111827'):'#fff', borderColor:sf===k?(VSTATUS[k]?.color||'#111827'):'#E5E7EB', color:sf===k?(VSTATUS[k]?.color||'#fff'):'#6B7280' }}>{l}</button>
        ))}
      </div>

      <div style={{ display:'grid', gridTemplateColumns:detail?'1fr 370px':'1fr', gap:20 }}>
        <div style={{ background:'#fff', borderRadius:14, border:'1px solid #F3F4F6', overflow:'hidden', boxShadow:'0 1px 4px rgba(0,0,0,0.04)' }}>
          {loading ? <div style={{ padding:52, textAlign:'center', color:'#CBD5E1' }}>Loading fleet…</div> : (
          <table style={{ width:'100%', borderCollapse:'collapse' }}>
            <thead><tr style={{ background:'#F9FAFB', borderBottom:'1px solid #F3F4F6' }}>
              {['Vehicle','Category','Status','KM','Price/Day','Actions'].map(h=><th key={h} style={{ padding:'11px 16px', textAlign:'left', fontSize:10, fontWeight:700, color:'#9CA3AF', letterSpacing:'0.08em', textTransform:'uppercase', whiteSpace:'nowrap' }}>{h}</th>)}
            </tr></thead>
            <tbody>
              {list.map(v=>{
                const s=VSTATUS[v.status]||VSTATUS.available;
                return (
                  <tr key={v.id} onClick={()=>setDetail(detail?.id===v.id?null:v)} style={{ borderBottom:'1px solid #F9FAFB', cursor:'pointer', background:detail?.id===v.id?'#F5F7FF':'' }}
                    onMouseEnter={e=>{if(detail?.id!==v.id)e.currentTarget.style.background='#F9FAFB'}}
                    onMouseLeave={e=>{if(detail?.id!==v.id)e.currentTarget.style.background=''}}>
                    <td style={{ padding:'13px 16px' }}>
                      <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                        {v.image?<img src={v.image} alt="" style={{ width:72,height:46,objectFit:'cover',borderRadius:8,border:'1px solid #F3F4F6',flexShrink:0 }}/>
                          :<div style={{ width:72,height:46,background:'#F3F4F6',borderRadius:8,display:'flex',alignItems:'center',justifyContent:'center',color:'#D1D5DB',flexShrink:0 }}><Ic d={I.car} size={22}/></div>}
                        <div>
                          <div style={{ fontWeight:700,fontSize:13,color:'#111827' }}>{v.name}</div>
                          <div style={{ fontSize:11,color:'#9CA3AF' }}>{v.year} · {v.transmission} · {v.fuel}</div>
                          {v.plate&&<div style={{ display:'inline-block',background:'#F3F4F6',borderRadius:4,padding:'1px 7px',fontSize:10,fontWeight:700,color:'#374151',fontFamily:'monospace',letterSpacing:'0.06em',marginTop:2 }}>{v.plate}</div>}
                        </div>
                      </div>
                    </td>
                    <td style={{ padding:'13px 16px',fontSize:12,color:'#6B7280' }}>{v.category}</td>
                    <td style={{ padding:'13px 16px' }} onClick={e=>e.stopPropagation()}>
                      <select value={v.status||'available'} onChange={e=>setVS(v.id,e.target.value)}
                        style={{ background:s.bg,color:s.color,border:`1.5px solid ${s.border}`,borderRadius:20,padding:'5px 11px',fontSize:11,fontWeight:700,cursor:'pointer',outline:'none',fontFamily:'var(--font-body)' }}>
                        {Object.entries(VSTATUS).map(([k,x])=><option key={k} value={k} style={{background:'#fff',color:'#111'}}>{x.label}</option>)}
                      </select>
                    </td>
                    <td style={{ padding:'13px 16px',fontSize:13,fontWeight:600,color:'#374151' }}>{v.currentKm?Number(v.currentKm).toLocaleString()+' km':(v.mileage||'—')}</td>
                    <td style={{ padding:'13px 16px',fontFamily:'var(--font-display)',fontSize:19,color:'var(--red)',letterSpacing:'0.03em' }}>€{v.price}</td>
                    <td style={{ padding:'13px 16px' }} onClick={e=>e.stopPropagation()}>
                      <div style={{ display:'flex',gap:5 }}>
                        <IconBtn icon={I.edit}  title="Edit"   onClick={()=>setModal({...v})}/>
                        <IconBtn icon={I.trash} title="Delete" danger onClick={()=>del(v.id,v.name)}/>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          )}
          {!loading&&list.length===0&&<div style={{ padding:52,textAlign:'center',color:'#CBD5E1',fontSize:13 }}>{vehicles.length===0?'No vehicles yet.':'No matches found.'}</div>}
        </div>
        {detail&&<FleetDetailPanel v={detail} onEdit={()=>setModal({...detail})} onDelete={()=>del(detail.id,detail.name)} onClose={()=>setDetail(null)} onStatus={setVS}/>}
      </div>
      {modal&&<VehicleModal key={modal.id||'new'} vehicle={modal} onSave={save} onClose={()=>setModal(null)}/>}
    </div>
  );
}

// ══════════════════════════════════════════════════════
// FLEET DETAIL PANEL
// ══════════════════════════════════════════════════════
function FleetDetailPanel({ v, onEdit, onDelete, onClose, onStatus }) {
  const s=VSTATUS[v.status]||VSTATUS.available;
  const maintLogs=LS.get(`r355_maint_${v.id}`,[]);
  const taxU=urgency(v.taxDueDate), insU=urgency(v.inspectionDueDate), isuU=urgency(v.insuranceExpiry);
  return (
    <div style={{ background:'#fff',borderRadius:14,border:'1px solid #F3F4F6',overflow:'hidden',boxShadow:'0 4px 20px rgba(0,0,0,0.08)',alignSelf:'start',position:'sticky',top:0 }}>
      <div style={{ position:'relative',height:190,background:'#F3F4F6' }}>
        {v.image?<img src={v.image} alt="" style={{ width:'100%',height:'100%',objectFit:'cover' }}/>:<div style={{ display:'flex',alignItems:'center',justifyContent:'center',height:'100%',color:'#D1D5DB' }}><Ic d={I.car} size={56}/></div>}
        <div style={{ position:'absolute',inset:0,background:'linear-gradient(to top,rgba(0,0,0,0.7) 0%,transparent 55%)' }}/>
        <button onClick={onClose} style={{ position:'absolute',top:10,right:10,background:'rgba(0,0,0,0.4)',border:'none',borderRadius:7,width:30,height:30,display:'flex',alignItems:'center',justifyContent:'center',color:'#fff',cursor:'pointer' }}><Ic d={I.close} size={13}/></button>
        <div style={{ position:'absolute',top:10,left:10 }}><SBadge status={v.status} map={VSTATUS}/></div>
        <div style={{ position:'absolute',bottom:14,left:16,right:16 }}>
          <div style={{ fontFamily:'var(--font-display)',fontSize:21,color:'#fff',letterSpacing:'0.04em',lineHeight:1 }}>{v.name}</div>
          <div style={{ fontSize:12,color:'rgba(255,255,255,0.6)',marginTop:3 }}>{v.year} · {v.category} · {v.plate||'No plate'}</div>
        </div>
      </div>
      <div style={{ padding:18,maxHeight:520,overflowY:'auto' }}>
        <div style={{ display:'grid',gridTemplateColumns:'1fr 1fr',gap:8,marginBottom:16 }}>
          {[['VIN',v.vin||'—'],['Transmission',v.transmission||'—'],['Fuel',v.fuel||'—'],['Seats',v.seats||'—'],['Mileage',v.mileage||'—'],['KM',v.currentKm?Number(v.currentKm).toLocaleString()+' km':'—'],['Price/Day',v.price?`€${v.price}`:'—'],['Fuel Level',v.fuelLevel?v.fuelLevel+'%':'—']].map(([l,val])=>(
            <div key={l} style={{ background:'#F9FAFB',borderRadius:8,padding:'9px 11px' }}>
              <div style={{ fontSize:10,fontWeight:700,color:'#CBD5E1',textTransform:'uppercase',letterSpacing:'0.07em',marginBottom:2 }}>{l}</div>
              <div style={{ fontSize:13,fontWeight:700,color:'#111827' }}>{val}</div>
            </div>
          ))}
        </div>
        <div style={{ marginBottom:14 }}>
          <div style={{ fontSize:11,fontWeight:700,color:'#9CA3AF',textTransform:'uppercase',letterSpacing:'0.07em',marginBottom:9 }}>Documents</div>
          {[['Road Tax',taxU,v.taxDueDate],['Tech. Inspection',insU,v.inspectionDueDate],['Insurance',isuU,v.insuranceExpiry]].map(([l,u,d])=>(
            <div key={l} style={{ display:'flex',justifyContent:'space-between',alignItems:'center',padding:'8px 0',borderBottom:'1px solid #F9FAFB' }}>
              <span style={{ fontSize:12,fontWeight:600,color:'#374151' }}>{l}</span>
              <span style={{ background:u.bg,color:u.color,borderRadius:20,padding:'2px 9px',fontSize:11,fontWeight:700 }}>{d?u.label:'Not set'}</span>
            </div>
          ))}
        </div>
        {maintLogs.length>0&&(
          <div style={{ marginBottom:14 }}>
            <div style={{ fontSize:11,fontWeight:700,color:'#9CA3AF',textTransform:'uppercase',letterSpacing:'0.07em',marginBottom:9 }}>Last Services</div>
            {[...maintLogs].reverse().slice(0,3).map(l=>(
              <div key={l.id} style={{ display:'flex',justifyContent:'space-between',padding:'7px 0',borderBottom:'1px solid #F9FAFB' }}>
                <div><div style={{ fontSize:12,fontWeight:600,color:'#111827' }}>{l.type}</div><div style={{ fontSize:11,color:'#9CA3AF' }}>{l.date}{l.km?` · ${Number(l.km).toLocaleString()} km`:''}</div></div>
                {l.cost&&<span style={{ fontSize:12,fontWeight:700,color:'#059669' }}>€{l.cost}</span>}
              </div>
            ))}
          </div>
        )}
        {v.notes&&<div style={{ background:'#FEF3C7',border:'1px solid #FCD34D',borderRadius:8,padding:'10px 12px',marginBottom:14,fontSize:12,color:'#92400E' }}>📝 {v.notes}</div>}
        <div style={{ display:'grid',gridTemplateColumns:'1fr 1fr',gap:6,marginBottom:8 }}>
          {Object.entries(VSTATUS).map(([k,x])=>(
            <button key={k} onClick={()=>onStatus(v.id,k)} style={{ padding:'7px',borderRadius:8,border:`1.5px solid ${v.status===k?x.color:x.border}`,background:v.status===k?x.bg:'#fff',color:v.status===k?x.color:'#9CA3AF',fontFamily:'var(--font-body)',fontSize:11,fontWeight:700,cursor:'pointer',transition:'all 0.12s' }}>{x.label}</button>
          ))}
        </div>
        <div style={{ display:'flex',gap:8,marginTop:4 }}>
          <PrimaryBtn onClick={onEdit} style={{ flex:1,justifyContent:'center',padding:'10px' }}><Ic d={I.edit} size={13}/> Edit</PrimaryBtn>
          <IconBtn icon={I.trash} danger onClick={onDelete}/>
        </div>
      </div>
    </div>
  );
}

// ══════════════════════════════════════════════════════
// VEHICLE MODAL (Add / Edit)
// ══════════════════════════════════════════════════════
// ─── VEHICLE FORM FIELDS (module-level, never recreated) ─
function VMInput({label, value, onChange, type, placeholder, span}) {
  const foc = e => { e.target.style.borderColor='var(--red)'; e.target.style.background='#fff'; };
  const blr = e => { e.target.style.borderColor='#E5E7EB'; e.target.style.background='#F9FAFB'; };
  return (
    <div style={{gridColumn:span===2?'span 2':'auto'}}>
      <label style={lbl}>{label}</label>
      <input type={type||'text'} value={value} onChange={e=>onChange(e.target.value)}
        placeholder={placeholder||''} style={{...inp,background:'#F9FAFB'}}
        onFocus={foc} onBlur={blr}/>
    </div>
  );
}
function VMSelect({label, value, onChange, opts, span}) {
  const foc = e => { e.target.style.borderColor='var(--red)'; e.target.style.background='#fff'; };
  const blr = e => { e.target.style.borderColor='#E5E7EB'; e.target.style.background='#F9FAFB'; };
  return (
    <div style={{gridColumn:span===2?'span 2':'auto'}}>
      <label style={lbl}>{label}</label>
      <select value={value} onChange={e=>onChange(e.target.value)}
        style={{...inp,background:'#F9FAFB'}} onFocus={foc} onBlur={blr}>
        {opts.map(o=><option key={o}>{o}</option>)}
      </select>
    </div>
  );
}

function VehicleModal({ vehicle, onSave, onClose }) {
  const isNew = !vehicle.id;
  const [sec,           setSec]           = useState('identity');
  const [name,          setName]          = useState(vehicle.name          || '');
  const [brand,         setBrand]         = useState(vehicle.brand         || '');
  const [model,         setModel]         = useState(vehicle.model         || '');
  const [year,          setYear]          = useState(String(vehicle.year   || 2024));
  const [color,         setColor]         = useState(vehicle.color         || '');
  const [vin,           setVin]           = useState(vehicle.vin           || '');
  const [plate,         setPlate]         = useState(vehicle.plate         || '');
  const [category,      setCategory]      = useState(vehicle.category      || 'Economic');
  const [seats,         setSeats]         = useState(String(vehicle.seats  || 5));
  const [transmission,  setTransmission]  = useState(vehicle.transmission  || 'Automatic');
  const [fuel,          setFuel]          = useState(vehicle.fuel          || 'Petrol');
  const [status,        setStatus]        = useState(vehicle.status        || 'available');
  const [price,         setPrice]         = useState(String(vehicle.price  || ''));
  const [image,         setImage]         = useState(vehicle.image         || '');
  const [taxAmount,     setTaxAmount]     = useState(String(vehicle.taxAmount    || ''));
  const [taxDate,       setTaxDate]       = useState(vehicle.taxDate       || '');
  const [taxDueDate,    setTaxDueDate]    = useState(vehicle.taxDueDate    || '');
  const [inspectionDate,setInspectionDate]= useState(vehicle.inspectionDate|| '');
  const [inspectionDue, setInspectionDue] = useState(vehicle.inspectionDueDate|| '');
  const [insuranceCo,   setInsuranceCo]   = useState(vehicle.insuranceCompany  || '');
  const [insuranceExp,  setInsuranceExp]  = useState(vehicle.insuranceExpiry   || '');
  const [notes,         setNotes]         = useState(vehicle.notes         || '');
  const [lastSvcDate,   setLastSvcDate]   = useState(vehicle.lastServiceDate   || '');
  const [lastSvcKm,     setLastSvcKm]     = useState(String(vehicle.lastServiceKm || ''));
  const [nextSvcDate,   setNextSvcDate]   = useState(vehicle.nextServiceDate   || '');
  const [nextSvcKm,     setNextSvcKm]     = useState(String(vehicle.nextServiceKm || ''));
  const [oilKm,         setOilKm]         = useState(String(vehicle.oilChangeKm  || ''));
  const [tirePsi,       setTirePsi]       = useState(String(vehicle.tirePressure || ''));
  const [fuelType,      setFuelType]      = useState(vehicle.fuelType      || 'Petrol');
  const [fuelLevel,     setFuelLevel]     = useState(String(vehicle.fuelLevel   || ''));
  const [currentKm,     setCurrentKm]     = useState(String(vehicle.currentKm   || ''));

  const foc = e => { e.target.style.borderColor='var(--red)'; e.target.style.background='#fff'; };
  const blr = e => { e.target.style.borderColor='#E5E7EB'; e.target.style.background='#F9FAFB'; };

  const SECS = [
    {key:'identity', label:'Identity',  icon:I.car},
    {key:'docs',     label:'Documents', icon:I.docs},
    {key:'service',  label:'Service',   icon:I.maint},
    {key:'fuel',     label:'Fuel & KM', icon:I.fuel},
  ];

  const handleSave = () => onSave({
    ...vehicle, name, brand, model, year, color, vin, plate, category,
    seats, transmission, fuel, status, price, image,
    taxAmount, taxDate, taxDueDate, inspectionDate, inspectionDueDate:inspectionDue,
    insuranceCompany:insuranceCo, insuranceExpiry:insuranceExp, notes,
    lastServiceDate:lastSvcDate, lastServiceKm:lastSvcKm,
    nextServiceDate:nextSvcDate, nextServiceKm:nextSvcKm,
    oilChangeKm:oilKm, tirePressure:tirePsi, fuelType, fuelLevel, currentKm,
  });



  return (
    <Modal onClose={onClose} wide>
      <div style={{padding:'20px 26px',borderBottom:'1px solid #F3F4F6',display:'flex',justifyContent:'space-between',alignItems:'center',flexShrink:0}}>
        <div style={{fontSize:17,fontWeight:700,color:'#111827'}}>{isNew?'➕ Add Vehicle':`✏️ Edit: ${vehicle.name||'Vehicle'}`}</div>
        <button onClick={onClose} style={{background:'none',border:'none',cursor:'pointer',color:'#9CA3AF',padding:4}}><Ic d={I.close} size={18}/></button>
      </div>
      <div style={{display:'flex',borderBottom:'1px solid #F3F4F6',padding:'0 26px',flexShrink:0}}>
        {SECS.map(s=>(
          <button key={s.key} onClick={()=>setSec(s.key)} style={{padding:'11px 16px',border:'none',background:'none',cursor:'pointer',fontSize:12,fontWeight:600,fontFamily:'var(--font-body)',color:sec===s.key?'var(--red)':'#9CA3AF',borderBottom:sec===s.key?'2px solid var(--red)':'2px solid transparent',display:'flex',alignItems:'center',gap:6}}>
            <Ic d={s.icon} size={12}/>{s.label}
          </button>
        ))}
      </div>
      <div style={{padding:'22px 26px',overflowY:'auto',flex:1}}>
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16}}>
          {sec==='identity' && <>
            <VMInput label="Vehicle Name"   value={name}         onChange={setName}         placeholder="e.g. Skoda Fabia White" span={2}/>
            <VMInput label="Brand"          value={brand}        onChange={setBrand}        placeholder="e.g. Skoda"/>
            <VMInput label="Model"          value={model}        onChange={setModel}        placeholder="e.g. Fabia"/>
            <VMInput label="Year"           value={year}         onChange={setYear}         type="number"/>
            <VMInput label="Color"          value={color}        onChange={setColor}        placeholder="e.g. White"/>
            <VMInput label="VIN Number"     value={vin}          onChange={setVin}          placeholder="17-character VIN" span={2}/>
            <VMInput label="License Plate"  value={plate}        onChange={setPlate}        placeholder="e.g. AA 001 BB"/>
            <VMSelect label="Category"      value={category}     onChange={setCategory}     opts={['Economic','4x4','Van','Sedan']}/>
            <VMInput label="Seats"          value={seats}        onChange={setSeats}        type="number"/>
            <VMSelect label="Transmission"  value={transmission} onChange={setTransmission} opts={['Automatic','Manual','Semi-Automatic']}/>
            <VMSelect label="Fuel Type"     value={fuel}         onChange={setFuel}         opts={['Petrol','Diesel','Electric','Hybrid','LPG']}/>
            <VMSelect label="Status"        value={status}       onChange={setStatus}       opts={['available','on_rent','maintenance','out_of_service']}/>
            <VMInput label="Price / Day (€)" value={price}       onChange={setPrice}        type="number"/>
            <div style={{gridColumn:'span 2'}}>
              <label style={lbl}>Vehicle Photo</label>
              <ImageUploader value={image} onChange={setImage}/>
            </div>
          </>}
          {sec==='docs' && <>
            <div style={{gridColumn:'span 2',background:'#FEF3C7',border:'1px solid #FCD34D',borderRadius:10,padding:'12px 16px',fontSize:13,color:'#92400E',fontWeight:600}}>⚠️ Technical inspection required every 2 years in Albania.</div>
            <VMInput label="Road Tax (€)"         value={taxAmount}     onChange={setTaxAmount}     type="number"/>
            <VMInput label="Tax Payment Date"     value={taxDate}       onChange={setTaxDate}       type="date"/>
            <VMInput label="Tax Due Date"         value={taxDueDate}    onChange={setTaxDueDate}    type="date"/>
            <div/>
            <VMInput label="Last Tech. Inspection" value={inspectionDate} onChange={setInspectionDate} type="date"/>
            <VMInput label="Next Inspection Due"   value={inspectionDue}  onChange={setInspectionDue}  type="date"/>
            <VMInput label="Insurance Company"     value={insuranceCo}    onChange={setInsuranceCo}    placeholder="e.g. Sigal"/>
            <VMInput label="Insurance Expiry"      value={insuranceExp}   onChange={setInsuranceExp}   type="date"/>
            <div style={{gridColumn:'span 2'}}>
              <label style={lbl}>Notes</label>
              <textarea value={notes} onChange={e=>setNotes(e.target.value)} placeholder="Additional notes…"
                style={{...inp,minHeight:70,resize:'vertical',background:'#F9FAFB'}} onFocus={foc} onBlur={blr}/>
            </div>
          </>}
          {sec==='service' && <>
            <VMInput label="Last Service Date" value={lastSvcDate} onChange={setLastSvcDate} type="date"/>
            <VMInput label="Last Service KM"   value={lastSvcKm}  onChange={setLastSvcKm}  type="number" placeholder="e.g. 45000"/>
            <VMInput label="Next Service Date" value={nextSvcDate} onChange={setNextSvcDate} type="date"/>
            <VMInput label="Next Service KM"   value={nextSvcKm}  onChange={setNextSvcKm}  type="number" placeholder="e.g. 50000"/>
            <VMInput label="Last Oil Change KM" value={oilKm}     onChange={setOilKm}      type="number" placeholder="e.g. 44000"/>
            <VMInput label="Tire Pressure (psi)" value={tirePsi}  onChange={setTirePsi}    placeholder="e.g. 32"/>
          </>}
          {sec==='fuel' && <>
            <VMSelect label="Fuel Type"      value={fuelType}  onChange={setFuelType}  opts={['Petrol','Diesel','Electric','Hybrid','LPG']}/>
            <VMInput  label="Fuel Level (%)" value={fuelLevel} onChange={setFuelLevel} type="number" placeholder="0–100"/>
            <VMInput  label="Current KM"     value={currentKm} onChange={setCurrentKm} type="number" placeholder="e.g. 47500"/>
          </>}
        </div>
      </div>
      <div style={{padding:'16px 26px',borderTop:'1px solid #F3F4F6',display:'flex',justifyContent:'flex-end',gap:10,flexShrink:0}}>
        <GhostBtn onClick={onClose}>Cancel</GhostBtn>
        <PrimaryBtn onClick={handleSave}>{isNew?'Add to Fleet':'Save Changes'}</PrimaryBtn>
      </div>
    </Modal>
  );
}


// ══════════════════════════════════════════════════════
// RESERVATIONS
// ══════════════════════════════════════════════════════
function ReservationsView({ showToast }) {
  const [bookings,setBookings]=useState([]); const [loading,setLoading]=useState(true);
  const [search,setSearch]=useState(''); const [sf,setSf]=useState('all'); const [detail,setDetail]=useState(null);
  useEffect(()=>{ fetch('/api/bookings').then(r=>r.json()).then(b=>{setBookings(b);setLoading(false);}).catch(()=>setLoading(false)); },[]);
  const updateStatus=async(id,status)=>{ await fetch(`/api/bookings/${id}`,{method:'PUT',headers:{'Content-Type':'application/json'},body:JSON.stringify({status})}); setBookings(p=>p.map(b=>b.id===id?{...b,status}:b)); if(detail?.id===id)setDetail(d=>({...d,status})); showToast('Updated'); };
  const deleteBooking=async(id)=>{ if(!window.confirm('Delete?'))return; await fetch(`/api/bookings/${id}`,{method:'DELETE'}); setBookings(p=>p.filter(b=>b.id!==id)); setDetail(null); showToast('Deleted'); };
  const sendConfirmation=async(b)=>{
    showToast(`Sending to ${b.customerName}…`);
    try { await emailjs.send(EJS_SERVICE,EJS_TEMPLATE,{customer_name:b.customerName,customer_email:b.email,booking_id:b.id,car_name:b.car?.name||`Car #${b.carId}`,pickup_date:b.pickupDate,return_date:b.returnDate,total_price:`$${b.totalPrice}`},EJS_KEY); await updateStatus(b.id,'confirmed'); showToast(`✅ Sent to ${b.email}!`); }
    catch(e){ showToast('❌ Failed to send email.'); }
  };
  const list=bookings.filter(b=>(`${b.customerName}${b.email}${b.car?.name}`).toLowerCase().includes(search.toLowerCase())&&(sf==='all'||b.status===sf));
  return (
    <div>
      <div style={{ display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:24 }}>
        <div><div style={{ fontFamily:'var(--font-display)',fontSize:32,letterSpacing:'0.04em',color:'#111827' }}>Reservations</div><div style={{ fontSize:13,color:'#9CA3AF',marginTop:3 }}>{bookings.length} total bookings</div></div>
      </div>
      <div style={{ display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:12,marginBottom:20 }}>
        {Object.entries(BSTATUS).map(([k,s])=>{ const n=bookings.filter(b=>b.status===k).length; return <div key={k} style={{ background:'#fff',borderRadius:12,padding:'16px',border:'1px solid #F3F4F6',boxShadow:'0 1px 4px rgba(0,0,0,0.04)' }}><div style={{ fontFamily:'var(--font-display)',fontSize:28,color:s.color,letterSpacing:'0.03em',lineHeight:1 }}>{n}</div><div style={{ fontSize:11,color:'#9CA3AF',fontWeight:700,textTransform:'capitalize',letterSpacing:'0.06em',marginTop:4 }}>{k}</div></div>; })}
      </div>
      <div style={{ display:'flex',gap:10,marginBottom:18,flexWrap:'wrap',alignItems:'center' }}>
        <div style={{ position:'relative',flex:1,minWidth:220 }}><div style={{ position:'absolute',left:12,top:'50%',transform:'translateY(-50%)',color:'#CBD5E1' }}><Ic d={I.search} size={14}/></div><input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search customer, email, car…" style={{ ...inp,paddingLeft:36 }}/></div>
        {['all','pending','confirmed','completed','cancelled'].map(k=><button key={k} onClick={()=>setSf(k)} style={{ padding:'8px 14px',borderRadius:20,fontSize:12,fontWeight:600,border:`1.5px solid ${sf===k?(BSTATUS[k]?.color||'#111'):'#E5E7EB'}`,background:sf===k?(BSTATUS[k]?.bg||'#111'):'#fff',color:sf===k?(BSTATUS[k]?.color||'#fff'):'#6B7280',cursor:'pointer',fontFamily:'var(--font-body)',textTransform:'capitalize' }}>{k}</button>)}
      </div>
      <div style={{ display:'grid',gridTemplateColumns:detail?'1fr 380px':'1fr',gap:20 }}>
        <div style={{ background:'#fff',borderRadius:14,border:'1px solid #F3F4F6',overflow:'hidden',boxShadow:'0 1px 4px rgba(0,0,0,0.04)' }}>
          <table style={{ width:'100%',borderCollapse:'collapse' }}>
            <thead><tr style={{ background:'#F9FAFB',borderBottom:'1px solid #F3F4F6' }}>{['Customer','Vehicle','Pickup','Return','Total','Status','Actions'].map(h=><th key={h} style={{ padding:'11px 16px',textAlign:'left',fontSize:10,fontWeight:700,color:'#9CA3AF',letterSpacing:'0.08em',textTransform:'uppercase',whiteSpace:'nowrap' }}>{h}</th>)}</tr></thead>
            <tbody>
              {loading?<tr><td colSpan={7} style={{ padding:32,textAlign:'center',color:'#CBD5E1' }}>Loading…</td></tr>
              :list.map(b=>(
                <tr key={b.id} onClick={()=>setDetail(detail?.id===b.id?null:b)} style={{ borderBottom:'1px solid #F9FAFB',cursor:'pointer',background:detail?.id===b.id?'#F5F7FF':'' }} onMouseEnter={e=>{if(detail?.id!==b.id)e.currentTarget.style.background='#F9FAFB'}} onMouseLeave={e=>{if(detail?.id!==b.id)e.currentTarget.style.background=''}}>
                  <td style={{ padding:'13px 16px' }}><div style={{ fontWeight:700,fontSize:13,color:'#111827' }}>{b.customerName}</div><div style={{ fontSize:11,color:'#9CA3AF' }}>{b.email}</div></td>
                  <td style={{ padding:'13px 16px',fontSize:13,color:'#374151' }}>{b.car?.name||`Car #${b.carId}`}</td>
                  <td style={{ padding:'13px 16px',fontSize:12,color:'#6B7280',whiteSpace:'nowrap' }}>{b.pickupDate}</td>
                  <td style={{ padding:'13px 16px',fontSize:12,color:'#6B7280',whiteSpace:'nowrap' }}>{b.returnDate}</td>
                  <td style={{ padding:'13px 16px',fontFamily:'var(--font-display)',fontSize:18,color:'var(--red)',letterSpacing:'0.03em' }}>${b.totalPrice}</td>
                  <td style={{ padding:'13px 16px' }}><SBadge status={b.status}/></td>
                  <td style={{ padding:'13px 16px' }} onClick={e=>e.stopPropagation()}><div style={{ display:'flex',gap:5 }}><IconBtn icon={I.mail} title="Send Confirmation" onClick={()=>sendConfirmation(b)}/><IconBtn icon={I.trash} title="Delete" danger onClick={()=>deleteBooking(b.id)}/></div></td>
                </tr>
              ))}
              {!loading&&list.length===0&&<tr><td colSpan={7} style={{ padding:48,textAlign:'center',color:'#CBD5E1',fontSize:13 }}>No bookings found.</td></tr>}
            </tbody>
          </table>
        </div>
        {detail&&(
          <div style={{ background:'#fff',borderRadius:14,border:'1px solid #F3F4F6',overflow:'hidden',boxShadow:'0 4px 20px rgba(0,0,0,0.08)',alignSelf:'start',position:'sticky',top:0 }}>
            <div style={{ padding:'18px 20px',borderBottom:'1px solid #F9FAFB',display:'flex',justifyContent:'space-between',alignItems:'center' }}>
              <div style={{ fontSize:15,fontWeight:700,color:'#111827' }}>Booking #{detail.id}</div>
              <button onClick={()=>setDetail(null)} style={{ background:'none',border:'none',cursor:'pointer',color:'#9CA3AF' }}><Ic d={I.close} size={16}/></button>
            </div>
            {detail.car?.image&&<img src={detail.car.image} alt="" style={{ width:'100%',height:160,objectFit:'cover' }}/>}
            <div style={{ padding:20 }}>
              {[['Customer',detail.customerName],['Email',detail.email],['Phone',detail.phone||'—'],['Vehicle',detail.car?.name||`Car #${detail.carId}`],['Pickup',detail.pickupDate],['Return',detail.returnDate],['Total',`$${detail.totalPrice}`]].map(([l,v])=>(
                <div key={l} style={{ display:'flex',justifyContent:'space-between',padding:'8px 0',borderBottom:'1px solid #F9FAFB' }}>
                  <span style={{ fontSize:12,fontWeight:600,color:'#9CA3AF' }}>{l}</span>
                  <span style={{ fontSize:13,fontWeight:700,color:'#111827' }}>{v}</span>
                </div>
              ))}
              <div style={{ marginTop:16 }}><label style={lbl}>Status</label><select value={detail.status} onChange={e=>updateStatus(detail.id,e.target.value)} style={{ ...inp }}>
                {['pending','confirmed','completed','cancelled'].map(s=><option key={s}>{s}</option>)}</select>
              </div>
              <div style={{ display:'flex',flexDirection:'column',gap:8,marginTop:14 }}>
                <PrimaryBtn onClick={()=>sendConfirmation(detail)} style={{ justifyContent:'center' }}><Ic d={I.mail} size={14}/> Send Confirmation Email</PrimaryBtn>
                <div style={{ fontSize:11,color:'#9CA3AF',textAlign:'center' }}>Sends from info@rent355.com · Auto-marks as Confirmed</div>
                <GhostBtn onClick={()=>deleteBooking(detail.id)} style={{ justifyContent:'center',color:'#DC2626',borderColor:'#FCA5A5' }}><Ic d={I.trash} size={13}/> Delete Booking</GhostBtn>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

// ══════════════════════════════════════════════════════
// CRM
// ══════════════════════════════════════════════════════
function CRMView() {
  const [bookings,setBookings]=useState([]); const [search,setSearch]=useState('');
  useEffect(()=>{ fetch('/api/bookings').then(r=>r.json()).then(setBookings).catch(()=>{}); },[]);
  const clients=Object.values(bookings.reduce((acc,b)=>{ const k=b.email; if(!acc[k])acc[k]={name:b.customerName,email:b.email,phone:b.phone||'—',bookings:[],total:0}; acc[k].bookings.push(b); acc[k].total+=b.totalPrice||0; return acc; },{})).filter(c=>(`${c.name}${c.email}`).toLowerCase().includes(search.toLowerCase()));
  const colors=['#DC2626','#2563EB','#059669','#7C3AED','#D97706','#0891B2'];
  return (
    <div>
      <div style={{ marginBottom:24 }}><div style={{ fontFamily:'var(--font-display)',fontSize:32,letterSpacing:'0.04em',color:'#111827' }}>CRM — Clients</div><div style={{ fontSize:13,color:'#9CA3AF',marginTop:3 }}>{clients.length} unique customers</div></div>
      <div style={{ position:'relative',maxWidth:380,marginBottom:20 }}><div style={{ position:'absolute',left:12,top:'50%',transform:'translateY(-50%)',color:'#CBD5E1' }}><Ic d={I.search} size={14}/></div><input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search clients…" style={{ ...inp,paddingLeft:36 }}/></div>
      <div style={{ display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(290px,1fr))',gap:16 }}>
        {clients.map((c,i)=>{ const color=colors[i%colors.length]; const initials=c.name.split(' ').map(n=>n[0]).join('').toUpperCase().substring(0,2); const last=c.bookings[c.bookings.length-1]; return (
          <div key={c.email} style={{ background:'#fff',borderRadius:14,border:'1px solid #F3F4F6',padding:22,boxShadow:'0 1px 4px rgba(0,0,0,0.04)',transition:'all 0.2s' }} onMouseEnter={e=>e.currentTarget.style.boxShadow='0 8px 24px rgba(0,0,0,0.08)'} onMouseLeave={e=>e.currentTarget.style.boxShadow='0 1px 4px rgba(0,0,0,0.04)'}>
            <div style={{ display:'flex',alignItems:'center',gap:13,marginBottom:16 }}>
              <div style={{ width:48,height:48,borderRadius:12,background:color,display:'flex',alignItems:'center',justifyContent:'center',fontSize:17,fontWeight:800,color:'#fff',flexShrink:0 }}>{initials}</div>
              <div style={{ flex:1 }}><div style={{ fontWeight:700,fontSize:15,color:'#111827' }}>{c.name}</div><div style={{ fontSize:12,color:'#9CA3AF' }}>{c.email}</div></div>
              <div style={{ textAlign:'right' }}><div style={{ fontFamily:'var(--font-display)',fontSize:22,color:'var(--red)',letterSpacing:'0.03em' }}>${c.total}</div><div style={{ fontSize:10,color:'#9CA3AF',fontWeight:700,textTransform:'uppercase' }}>spent</div></div>
            </div>
            <div style={{ display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:0,borderTop:'1px solid #F9FAFB',paddingTop:14 }}>
              {[[c.bookings.length,'Bookings'],[c.phone,'Phone'],[last?last.status:'—','Last']].map(([v,l],j)=>(
                <div key={j} style={{ textAlign:'center',borderRight:j<2?'1px solid #F9FAFB':'none' }}>
                  <div style={{ fontSize:13,fontWeight:700,color:'#111827' }}>{j===2?<SBadge status={v}/>:v}</div>
                  <div style={{ fontSize:10,color:'#9CA3AF',fontWeight:700,textTransform:'uppercase',letterSpacing:'0.06em',marginTop:j===2?0:3 }}>{l}</div>
                </div>
              ))}
            </div>
          </div>
        );})}
        {clients.length===0&&<div style={{ color:'#CBD5E1',fontSize:13,gridColumn:'span 3',padding:40,textAlign:'center' }}>No clients yet.</div>}
      </div>
    </div>
  );
}

const TYPES=['Oil Change','Tire Rotation','Tire Change','Brake Service','Full Service','Wash & Detail','Repair','Insurance Renewal','Registration','Technical Inspection','Battery','AC Service','Other'];

function MCard({ v, showToast }) {
  const [logs,setLogs]=useState(()=>LS.get(`r355_maint_${v.id}`,[]));
  const [form,setForm]=useState({type:'Oil Change',date:new Date().toISOString().split('T')[0],km:'',cost:'',notes:''});
  const [open,setOpen]=useState(false);
  const nextDays=daysUntil(v.nextServiceDate);
  const kmLeft=v.nextServiceKm&&v.currentKm?Number(v.nextServiceKm)-Number(v.currentKm):null;
  const urgent=(nextDays!==null&&nextDays<30)||(kmLeft!==null&&kmLeft<1000);
  const addLog=()=>{ if(!form.date)return; const nl=[...logs,{...form,id:Date.now()}]; setLogs(nl); LS.set(`r355_maint_${v.id}`,nl); setForm({type:'Oil Change',date:new Date().toISOString().split('T')[0],km:'',cost:'',notes:''}); showToast('Service logged ✅'); };
  const delLog=id=>{ const nl=logs.filter(l=>l.id!==id); setLogs(nl); LS.set(`r355_maint_${v.id}`,nl); };
  return (
    <div style={{ background:'#fff',borderRadius:14,border:`1.5px solid ${urgent?'#FCD34D':'#F3F4F6'}`,overflow:'hidden',boxShadow:'0 1px 4px rgba(0,0,0,0.04)' }}>
      <div style={{ display:'flex',alignItems:'center',gap:12,padding:'14px 18px',borderBottom:'1px solid #F9FAFB',background:urgent?'#FFFBEB':'#fff',cursor:'pointer' }} onClick={()=>setOpen(!open)}>
        {v.image?<img src={v.image} alt="" style={{ width:60,height:40,objectFit:'cover',borderRadius:8,border:'1px solid #F3F4F6',flexShrink:0 }}/>:<div style={{ width:60,height:40,background:'#F3F4F6',borderRadius:8,display:'flex',alignItems:'center',justifyContent:'center',color:'#D1D5DB',flexShrink:0 }}><Ic d={I.car} size={18}/></div>}
        <div style={{ flex:1 }}><div style={{ fontWeight:700,fontSize:13,color:'#111827' }}>{v.name||`${v.brand} ${v.model}`}</div><div style={{ fontSize:11,color:'#9CA3AF' }}>{v.plate||''} · {v.currentKm?Number(v.currentKm).toLocaleString()+' km':'No KM'} · {logs.length} records</div></div>
        {urgent&&<span style={{ background:'#FEF3C7',color:'#D97706',borderRadius:7,padding:'3px 9px',fontSize:11,fontWeight:700 }}>⚠️ Due</span>}
      </div>
      {open&&(
        <div style={{ padding:18 }}>
          <div style={{ display:'grid',gridTemplateColumns:'1fr 1fr',gap:8,marginBottom:14 }}>
            <div style={{ background:'#F9FAFB',borderRadius:9,padding:12 }}><div style={{ fontSize:10,fontWeight:700,color:'#9CA3AF',textTransform:'uppercase',letterSpacing:'0.07em',marginBottom:4 }}>Last Service</div><div style={{ fontSize:13,fontWeight:700,color:'#111827' }}>{v.lastServiceDate||'—'}</div><div style={{ fontSize:11,color:'#9CA3AF' }}>{v.lastServiceKm?Number(v.lastServiceKm).toLocaleString()+' km':'—'}</div></div>
            <div style={{ background:'#F9FAFB',borderRadius:9,padding:12 }}><div style={{ fontSize:10,fontWeight:700,color:'#9CA3AF',textTransform:'uppercase',letterSpacing:'0.07em',marginBottom:4 }}>Next Service</div><div style={{ fontSize:13,fontWeight:700,color:nextDays!==null&&nextDays<30?'#D97706':'#111827' }}>{v.nextServiceDate||'—'}</div><div style={{ fontSize:11,color:'#9CA3AF' }}>{kmLeft!==null?Number(kmLeft).toLocaleString()+' km left':'—'}</div></div>
          </div>
          <div style={{ background:'#F9FAFB',borderRadius:10,padding:14,marginBottom:14,border:'1px solid #F3F4F6' }}>
            <div style={{ fontSize:11,fontWeight:700,color:'#9CA3AF',textTransform:'uppercase',letterSpacing:'0.07em',marginBottom:12 }}>Log New Service</div>
            <div style={{ display:'grid',gridTemplateColumns:'1fr 1fr',gap:10,marginBottom:10 }}>
              <div><label style={lbl}>Type</label><select style={inp} value={form.type} onChange={e=>setForm(f=>({...f,type:e.target.value}))}>{TYPES.map(t=><option key={t}>{t}</option>)}</select></div>
              <div><label style={lbl}>Date</label><input type="date" style={inp} value={form.date} onChange={e=>setForm(f=>({...f,date:e.target.value}))}/></div>
              <div><label style={lbl}>KM</label><input style={inp} value={form.km} onChange={e=>setForm(f=>({...f,km:e.target.value}))} placeholder="e.g. 47500"/></div>
              <div><label style={lbl}>Cost (€)</label><input style={inp} value={form.cost} onChange={e=>setForm(f=>({...f,cost:e.target.value}))} placeholder="e.g. 85"/></div>
            </div>
            <input style={{ ...inp,marginBottom:10 }} value={form.notes} onChange={e=>setForm(f=>({...f,notes:e.target.value}))} placeholder="Notes (optional)"/>
            <PrimaryBtn onClick={addLog} style={{ padding:'8px 18px',fontSize:12 }}><Ic d={I.plus} size={12}/> Add Record</PrimaryBtn>
          </div>
          {logs.length>0&&<div style={{ maxHeight:200,overflowY:'auto' }}>{[...logs].reverse().map(log=>(
            <div key={log.id} style={{ display:'flex',justifyContent:'space-between',alignItems:'center',padding:'10px 12px',background:'#fff',border:'1px solid #F3F4F6',borderRadius:9,marginBottom:6 }}>
              <div><div style={{ display:'flex',alignItems:'center',gap:7 }}><span style={{ fontSize:13,fontWeight:700,color:'#111827' }}>{log.type}</span>{log.cost&&<span style={{ background:'#DCFCE7',color:'#059669',borderRadius:20,padding:'1px 8px',fontSize:11,fontWeight:700 }}>€{log.cost}</span>}{log.km&&<span style={{ background:'#DBEAFE',color:'#2563EB',borderRadius:20,padding:'1px 8px',fontSize:11,fontWeight:700 }}>{Number(log.km).toLocaleString()} km</span>}</div><div style={{ fontSize:11,color:'#9CA3AF' }}>{log.date}{log.notes?` · ${log.notes}`:''}</div></div>
              <IconBtn icon={I.trash} danger onClick={()=>delLog(log.id)}/>
            </div>
          ))}</div>}
        </div>
      )}
    </div>
  );
}
// ══════════════════════════════════════════════════════
// MAINTENANCE
// ══════════════════════════════════════════════════════
function MaintenanceView({ showToast }) {
  const { vehicles } = useFleet();

  return (
    <div>
      <div style={{ marginBottom:24 }}><div style={{ fontFamily:'var(--font-display)',fontSize:32,letterSpacing:'0.04em',color:'#111827' }}>Maintenance</div><div style={{ fontSize:13,color:'#9CA3AF',marginTop:3 }}>Service schedules and history per vehicle</div></div>
      <div style={{ display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(400px,1fr))',gap:14 }}>
        {vehicles.map(v=><MCard key={v.id} v={v} showToast={showToast}/>)}
        {vehicles.length===0&&<div style={{ color:'#CBD5E1',padding:40 }}>No vehicles yet. Add vehicles in Fleet first.</div>}
      </div>
    </div>
  );
}

// ══════════════════════════════════════════════════════
// DOCUMENTS
// ══════════════════════════════════════════════════════
function DocumentsView({ showToast }) {
  const { vehicles, reload: refreshFleet } = useFleet();
  const [editing, setEditing] = useState(null); // { v, type }
  const [form, setForm]       = useState({});

  const openEdit = (v, type) => {
    setEditing({ v, type });
    if (type === 'Road Tax')        setForm({ paid: v.taxDate||'',        due: v.taxDueDate||'',      amount: v.taxAmount||'' });
    if (type === 'Tech. Inspection')setForm({ paid: v.inspectionDate||'', due: v.inspectionDueDate||'', amount: '' });
    if (type === 'Insurance')       setForm({ paid: v.insuranceDate||'',  due: v.insuranceExpiry||'', company: v.insuranceCompany||'' });
  };

  const saveDoc = () => {
    if (!editing) return;
    const { v, type } = editing;
    const extra = getFleetExtra();
    const ex    = extra[v.id] || {};
    if (type === 'Road Tax')         Object.assign(ex, { taxDate: form.paid, taxDueDate: form.due, taxAmount: form.amount });
    if (type === 'Tech. Inspection') Object.assign(ex, { inspectionDate: form.paid, inspectionDueDate: form.due });
    if (type === 'Insurance')        Object.assign(ex, { insuranceDate: form.paid, insuranceExpiry: form.due, insuranceCompany: form.company });
    extra[v.id] = ex;
    LS.set('r355_fleet_extra', extra);
    if (refreshFleet) refreshFleet();
    showToast('Document updated ✅');
    setEditing(null);
  };

  const all = vehicles.flatMap(v => {
    const ex = (LS.get('r355_fleet_extra',{})||{})[v.id] || {};
    return [
      { v, type:'Road Tax',         paid: ex.taxDate||v.taxDate||'',               due: ex.taxDueDate||v.taxDueDate||'',           extra: (ex.taxAmount||v.taxAmount)?`€${ex.taxAmount||v.taxAmount}`:'', note:'Annual' },
      { v, type:'Tech. Inspection', paid: ex.inspectionDate||v.inspectionDate||'', due: ex.inspectionDueDate||v.inspectionDueDate||'', extra:'', note:'Every 2 years' },
      { v, type:'Insurance',        paid: ex.insuranceDate||v.insuranceDate||'',   due: ex.insuranceExpiry||v.insuranceExpiry||'', extra: ex.insuranceCompany||v.insuranceCompany||'', note:'Annual' },
    ];
  }).sort((a,b) => { const da=daysUntil(a.due), db=daysUntil(b.due); if(da===null)return 1; if(db===null)return -1; return da-db; });

  const FI = ({ label, fkey, type='date' }) => (
    <div>
      <label style={lbl}>{label}</label>
      <input type={type} value={form[fkey]||''} onChange={e => setForm(f=>({...f,[fkey]:e.target.value}))}
        style={{...inp, background:'#F9FAFB'}}/>
    </div>
  );

  return (
    <div>
      <div style={{ marginBottom:24 }}>
        <div style={{ fontFamily:'var(--font-display)',fontSize:32,letterSpacing:'0.04em',color:'#111827' }}>Documents & Taxes</div>
        <div style={{ fontSize:13,color:'#9CA3AF',marginTop:3 }}>Click any row to update dates — road tax, inspections, insurance</div>
      </div>

      {all.filter(a=>a.due&&daysUntil(a.due)<=30).length>0&&(
        <div style={{ background:'#FEF3C7',border:'1px solid #FCD34D',borderRadius:12,padding:'14px 18px',marginBottom:20,display:'flex',alignItems:'center',gap:10 }}>
          <Ic d={I.warn} size={20}/>
          <div style={{ fontSize:13,fontWeight:600,color:'#92400E' }}>⚠️ {all.filter(a=>a.due&&daysUntil(a.due)<=30).length} document(s) expire within 30 days.</div>
        </div>
      )}

      <div style={{ background:'#fff',borderRadius:14,border:'1px solid #F3F4F6',overflow:'hidden',boxShadow:'0 1px 4px rgba(0,0,0,0.04)' }}>
        <table style={{ width:'100%',borderCollapse:'collapse' }}>
          <thead>
            <tr style={{ background:'#F9FAFB',borderBottom:'1px solid #F3F4F6' }}>
              {['Vehicle','Plate','Document','Paid/Issued','Due Date','Status','Info',''].map(h=>(
                <th key={h} style={{ padding:'11px 16px',textAlign:'left',fontSize:10,fontWeight:700,color:'#9CA3AF',letterSpacing:'0.08em',textTransform:'uppercase',whiteSpace:'nowrap' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {all.map((a,i) => {
              const u = urgency(a.due);
              return (
                <tr key={i} style={{ borderBottom:'1px solid #F9FAFB', cursor:'pointer' }}
                  onMouseEnter={e=>e.currentTarget.style.background='#F9FAFB'}
                  onMouseLeave={e=>e.currentTarget.style.background=''}>
                  <td style={{ padding:'13px 16px' }}>
                    <div style={{ display:'flex',alignItems:'center',gap:10 }}>
                      {a.v.image
                        ? <img src={a.v.image} alt="" style={{ width:52,height:34,objectFit:'cover',borderRadius:6,border:'1px solid #F3F4F6',flexShrink:0 }}/>
                        : <div style={{ width:52,height:34,background:'#F3F4F6',borderRadius:6,display:'flex',alignItems:'center',justifyContent:'center',color:'#D1D5DB',flexShrink:0 }}><Ic d={I.car} size={14}/></div>
                      }
                      <div>
                        <div style={{ fontWeight:700,fontSize:13,color:'#111827' }}>{a.v.name||`${a.v.brand} ${a.v.model}`}</div>
                        <div style={{ fontSize:11,color:'#9CA3AF' }}>{a.v.year}</div>
                      </div>
                    </div>
                  </td>
                  <td style={{ padding:'13px 16px' }}>
                    <span style={{ background:'#F3F4F6',borderRadius:5,padding:'2px 9px',fontSize:12,fontWeight:700,color:'#374151',fontFamily:'monospace' }}>{a.v.plate||'—'}</span>
                  </td>
                  <td style={{ padding:'13px 16px',fontSize:13,fontWeight:700,color:'#111827' }}>{a.type}</td>
                  <td style={{ padding:'13px 16px',fontSize:12,color:'#6B7280' }}>{a.paid||'—'}</td>
                  <td style={{ padding:'13px 16px',fontSize:12,color:'#6B7280' }}>{a.due||'—'}</td>
                  <td style={{ padding:'13px 16px' }}>
                    {a.due
                      ? <span style={{ background:u.bg,color:u.color,borderRadius:20,padding:'3px 11px',fontSize:11,fontWeight:700 }}>{u.label}</span>
                      : <span style={{ color:'#CBD5E1',fontSize:12 }}>Not set</span>
                    }
                  </td>
                  <td style={{ padding:'13px 16px',fontSize:12,color:'#6B7280' }}>
                    {a.extra&&<span style={{ fontWeight:600,color:'#374151',marginRight:8 }}>{a.extra}</span>}{a.note}
                  </td>
                  <td style={{ padding:'13px 16px' }}>
                    <button onClick={() => openEdit(a.v, a.type)}
                      style={{ background:'#F3F4F6',border:'none',borderRadius:8,padding:'6px 14px',fontSize:12,fontWeight:600,color:'#374151',cursor:'pointer',fontFamily:'var(--font-body)',display:'flex',alignItems:'center',gap:5 }}>
                      <Ic d={I.edit} size={12}/> Edit
                    </button>
                  </td>
                </tr>
              );
            })}
            {all.length===0&&(
              <tr><td colSpan={8} style={{ padding:48,textAlign:'center',color:'#CBD5E1',fontSize:13 }}>No vehicles yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Edit Modal */}
      {editing && (
        <Modal onClose={() => setEditing(null)}>
          <div style={{ padding:'28px 28px 22px' }}>
            <div style={{ fontFamily:'var(--font-display)',fontSize:22,letterSpacing:'0.04em',color:'#111827',marginBottom:4 }}>
              {editing.type}
            </div>
            <div style={{ fontSize:13,color:'#9CA3AF',marginBottom:22 }}>
              {editing.v.name} {editing.v.plate ? `· ${editing.v.plate}` : ''}
            </div>

            <div style={{ display:'grid',gridTemplateColumns:'1fr 1fr',gap:14,marginBottom:18 }}>
              <FI label="Paid / Issued Date" fkey="paid" />
              <FI label="Expiry / Due Date"  fkey="due"  />
              {editing.type === 'Road Tax'   && <FI label="Amount (€)" fkey="amount" type="text" />}
              {editing.type === 'Insurance'  && <FI label="Insurance Company" fkey="company" type="text" />}
            </div>

            <div style={{ display:'flex',gap:10,justifyContent:'flex-end' }}>
              <GhostBtn onClick={() => setEditing(null)}>Cancel</GhostBtn>
              <PrimaryBtn onClick={saveDoc}>Save Document</PrimaryBtn>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
}

function FRow({ v, onUpdate }) {
  const [editing,setEditing]=useState(false); const [km,setKm]=useState(v.currentKm||0); const [fl,setFl]=useState(v.fuelLevel||100);
  const fuelPct=parseInt(v.fuelLevel)||0; const fc=fuelPct<20?'#DC2626':fuelPct<40?'#D97706':'#059669';
  const kmLeft=v.nextServiceKm&&v.currentKm?Number(v.nextServiceKm)-Number(v.currentKm):null;
  const save=()=>{ onUpdate(v.id,{currentKm:parseInt(km),fuelLevel:Math.min(100,Math.max(0,parseInt(fl)))}); setEditing(false); };
  return (
    <tr style={{ borderBottom:'1px solid #F9FAFB' }} onMouseEnter={e=>e.currentTarget.style.background='#F9FAFB'} onMouseLeave={e=>e.currentTarget.style.background=''}>
      <td style={{ padding:'13px 16px' }}><div style={{ display:'flex',alignItems:'center',gap:10 }}>{v.image?<img src={v.image} alt="" style={{ width:56,height:36,objectFit:'cover',borderRadius:7,border:'1px solid #F3F4F6',flexShrink:0 }}/>:<div style={{ width:56,height:36,background:'#F3F4F6',borderRadius:7,display:'flex',alignItems:'center',justifyContent:'center',color:'#D1D5DB',flexShrink:0 }}><Ic d={I.car} size={16}/></div>}<div><div style={{ fontWeight:700,fontSize:13,color:'#111827' }}>{v.name||`${v.brand} ${v.model}`}</div><div style={{ fontSize:11,color:'#9CA3AF' }}>{v.year} · {v.fuelType||v.fuel||'—'}</div></div></div></td>
      <td style={{ padding:'13px 16px' }}><span style={{ background:'#F3F4F6',borderRadius:5,padding:'2px 9px',fontSize:12,fontWeight:700,color:'#374151',fontFamily:'monospace' }}>{v.plate||'—'}</span></td>
      <td style={{ padding:'13px 16px' }}><div style={{ display:'flex',alignItems:'center',gap:8 }}><div style={{ flex:1,background:'#F3F4F6',borderRadius:99,height:9,overflow:'hidden',minWidth:70 }}><div style={{ width:`${fuelPct}%`,height:'100%',background:fc,borderRadius:99 }}/></div><span style={{ fontSize:12,fontWeight:700,color:fc,minWidth:30 }}>{fuelPct}%</span></div></td>
      <td style={{ padding:'13px 16px',fontSize:13,fontWeight:700,color:'#111827' }}>{v.currentKm?Number(v.currentKm).toLocaleString()+' km':'—'}</td>
      <td style={{ padding:'13px 16px',fontSize:12,color:'#6B7280' }}>{v.lastServiceKm?Number(v.lastServiceKm).toLocaleString()+' km':'—'}</td>
      <td style={{ padding:'13px 16px',fontSize:12,color:'#6B7280' }}>{v.nextServiceKm?Number(v.nextServiceKm).toLocaleString()+' km':'—'}</td>
      <td style={{ padding:'13px 16px' }}>{kmLeft!==null?<span style={{ background:kmLeft<0?'#FEE2E2':kmLeft<2000?'#FEF3C7':'#DCFCE7',color:kmLeft<0?'#DC2626':kmLeft<2000?'#D97706':'#059669',borderRadius:20,padding:'3px 11px',fontSize:12,fontWeight:700 }}>{kmLeft>0?`${Number(kmLeft).toLocaleString()} km`:'Overdue!'}</span>:'—'}</td>
      <td style={{ padding:'13px 16px' }}>{editing?(
        <div style={{ display:'flex',gap:6,alignItems:'center',flexWrap:'wrap' }}>
          <input value={km} onChange={e=>setKm(e.target.value)} placeholder="KM" style={{ width:80,padding:'6px 9px',border:'1.5px solid var(--red)',borderRadius:7,fontSize:12,fontFamily:'var(--font-body)',outline:'none' }}/>
          <input value={fl} onChange={e=>setFl(e.target.value)} placeholder="Fuel%" style={{ width:65,padding:'6px 9px',border:'1.5px solid #E5E7EB',borderRadius:7,fontSize:12,fontFamily:'var(--font-body)',outline:'none' }}/>
          <button onClick={save} style={{ background:'var(--red)',color:'#fff',border:'none',borderRadius:7,padding:'6px 12px',fontSize:12,fontWeight:700,cursor:'pointer',fontFamily:'var(--font-body)' }}>Save</button>
          <button onClick={()=>setEditing(false)} style={{ background:'#F3F4F6',color:'#9CA3AF',border:'none',borderRadius:7,padding:'6px 9px',fontSize:12,cursor:'pointer',fontFamily:'var(--font-body)' }}>✕</button>
        </div>
      ):<GhostBtn onClick={()=>setEditing(true)} style={{ padding:'6px 14px',fontSize:12 }}><Ic d={I.edit} size={12}/> Update</GhostBtn>}</td>
    </tr>
  );
}
// ══════════════════════════════════════════════════════
// FUEL & MILEAGE
// ══════════════════════════════════════════════════════
function FuelMileageView({ showToast }) {
  const [vehicles,setVehicles]=useState([]);
  useEffect(()=>{ loadFleet().then(setVehicles).catch(()=>{}); },[]);
  const update=(id,fields)=>{
    const extra=getFleetExtra(); extra[id]={...(extra[id]||{}),...fields}; LS.set('r355_fleet_extra',extra);
    const updated=vehicles.map(x=>x.id===id?{...x,...fields}:x); setVehicles(updated);
    fetch(`/api/cars/${id}`,{method:'PUT',headers:{'Content-Type':'application/json'},body:JSON.stringify({available:fields.status?fields.status==='available':undefined})}).catch(()=>{});
    showToast('Updated ✅');
  };

  return (
    <div>
      <div style={{ marginBottom:24 }}><div style={{ fontFamily:'var(--font-display)',fontSize:32,letterSpacing:'0.04em',color:'#111827' }}>Fuel & Mileage</div><div style={{ fontSize:13,color:'#9CA3AF',marginTop:3 }}>Track fuel levels, mileage and service intervals</div></div>
      <div style={{ background:'#fff',borderRadius:14,border:'1px solid #F3F4F6',overflow:'hidden',boxShadow:'0 1px 4px rgba(0,0,0,0.04)' }}>
        <div style={{ overflowX:'auto' }}>
          <table style={{ width:'100%',borderCollapse:'collapse',minWidth:800 }}>
            <thead><tr style={{ background:'#F9FAFB',borderBottom:'1px solid #F3F4F6' }}>{['Vehicle','Plate','Fuel Level','Current KM','Last Svc KM','Next Svc KM','KM to Service','Update'].map(h=><th key={h} style={{ padding:'11px 16px',textAlign:'left',fontSize:10,fontWeight:700,color:'#9CA3AF',letterSpacing:'0.08em',textTransform:'uppercase',whiteSpace:'nowrap' }}>{h}</th>)}</tr></thead>
            <tbody>{vehicles.map(v=><FRow key={v.id} v={v} onUpdate={update}/>)}{vehicles.length===0&&<tr><td colSpan={8} style={{ padding:48,textAlign:'center',color:'#CBD5E1',fontSize:13 }}>No vehicles yet.</td></tr>}</tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

// ══════════════════════════════════════════════════════
// ANALYTICS
// ══════════════════════════════════════════════════════
function AnalyticsView() {
  const [bookings,setBookings]=useState([]);
  const { vehicles } = useFleet();
  useEffect(()=>{ fetch('/api/bookings').then(r=>r.json()).then(setBookings).catch(()=>{}); },[]);
  const totalRev=bookings.filter(b=>b.status==='completed').reduce((s,b)=>s+(b.totalPrice||0),0);
  const avgBooking=bookings.length>0?Math.round(bookings.reduce((s,b)=>s+(b.totalPrice||0),0)/bookings.length):0;
  const fleetUtil=vehicles.length>0?Math.round(vehicles.filter(v=>v.status==='on_rent').length/vehicles.length*100):0;
  const byCategory=['Economic','4x4','Van','Sedan'].map(cat=>{ const cv=vehicles.filter(v=>v.category===cat); const cb=bookings.filter(b=>cv.some(v=>v.id===b.carId)); return {cat,bookings:cb.length,revenue:cb.reduce((s,b)=>s+(b.totalPrice||0),0)}; });
  const maxRev=Math.max(...byCategory.map(c=>c.revenue),1);
  const topCars=[...vehicles].map(v=>({v,bookingCount:bookings.filter(b=>b.carId===v.id).length,revenue:bookings.filter(b=>b.carId===v.id).reduce((s,b)=>s+(b.totalPrice||0),0)})).sort((a,b)=>b.revenue-a.revenue).slice(0,5);
  const KPIS=[{l:'Completed Revenue',v:`$${totalRev.toLocaleString()}`,c:'#C41230'},{l:'Avg Booking',v:`$${avgBooking}`,c:'#2563EB'},{l:'Fleet Utilization',v:`${fleetUtil}%`,c:'#059669'},{l:'Total Bookings',v:bookings.length,c:'#7C3AED'}];
  return (
    <div>
      <div style={{ marginBottom:24 }}><div style={{ fontFamily:'var(--font-display)',fontSize:32,letterSpacing:'0.04em',color:'#111827' }}>Analytics</div><div style={{ fontSize:13,color:'#9CA3AF',marginTop:3 }}>Business performance and fleet insights</div></div>
      <div style={{ display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:14,marginBottom:24 }}>
        {KPIS.map((k,i)=><div key={i} style={{ background:'#fff',borderRadius:12,padding:'20px',border:'1px solid #F3F4F6',boxShadow:'0 1px 4px rgba(0,0,0,0.04)' }}><div style={{ fontFamily:'var(--font-display)',fontSize:30,color:k.c,letterSpacing:'0.03em',lineHeight:1,marginBottom:4 }}>{k.v}</div><div style={{ fontSize:11,fontWeight:700,color:'#9CA3AF',textTransform:'uppercase',letterSpacing:'0.07em' }}>{k.l}</div></div>)}
      </div>
      <div style={{ display:'grid',gridTemplateColumns:'1fr 1fr',gap:20 }}>
        <div style={{ background:'#fff',borderRadius:14,border:'1px solid #F3F4F6',padding:24,boxShadow:'0 1px 4px rgba(0,0,0,0.04)' }}>
          <div style={{ fontSize:15,fontWeight:700,color:'#111827',marginBottom:20 }}>Revenue by Category</div>
          {byCategory.map((c,i)=>{ const pct=Math.round(c.revenue/maxRev*100); const colors=['#C41230','#2563EB','#059669','#7C3AED']; return (
            <div key={c.cat} style={{ marginBottom:16 }}><div style={{ display:'flex',justifyContent:'space-between',marginBottom:6 }}><span style={{ fontSize:13,fontWeight:600,color:'#374151' }}>{c.cat}</span><span style={{ fontSize:13,fontWeight:700,color:'#111827' }}>${c.revenue} <span style={{ color:'#9CA3AF',fontWeight:400 }}>({c.bookings})</span></span></div><div style={{ background:'#F3F4F6',borderRadius:99,height:10,overflow:'hidden' }}><div style={{ width:`${pct}%`,height:'100%',background:colors[i],borderRadius:99,transition:'width 0.8s' }}/></div></div>
          );})}
        </div>
        <div style={{ background:'#fff',borderRadius:14,border:'1px solid #F3F4F6',padding:24,boxShadow:'0 1px 4px rgba(0,0,0,0.04)' }}>
          <div style={{ fontSize:15,fontWeight:700,color:'#111827',marginBottom:20 }}>Top Performing Vehicles</div>
          {topCars.map((item,i)=>(
            <div key={item.v.id} style={{ display:'flex',alignItems:'center',gap:12,padding:'10px 0',borderBottom:'1px solid #F9FAFB' }}>
              <div style={{ width:30,height:30,borderRadius:'50%',background:i===0?'#FFD700':i===1?'#C0C0C0':i===2?'#CD7F32':'#F3F4F6',display:'flex',alignItems:'center',justifyContent:'center',fontSize:12,fontWeight:800,color:i<3?'#fff':'#9CA3AF',flexShrink:0 }}>{i+1}</div>
              {item.v.image&&<img src={item.v.image} alt="" style={{ width:54,height:34,objectFit:'cover',borderRadius:7,flexShrink:0 }}/>}
              <div style={{ flex:1 }}><div style={{ fontSize:13,fontWeight:700,color:'#111827' }}>{item.v.name||`${item.v.brand} ${item.v.model}`}</div><div style={{ fontSize:11,color:'#9CA3AF' }}>{item.bookingCount} bookings</div></div>
              <div style={{ fontFamily:'var(--font-display)',fontSize:20,color:'var(--red)',letterSpacing:'0.03em' }}>${item.revenue}</div>
            </div>
          ))}
          {topCars.length===0&&<div style={{ color:'#CBD5E1',fontSize:13,textAlign:'center',padding:20 }}>No data yet.</div>}
        </div>
        <div style={{ background:'#fff',borderRadius:14,border:'1px solid #F3F4F6',padding:24,boxShadow:'0 1px 4px rgba(0,0,0,0.04)' }}>
          <div style={{ fontSize:15,fontWeight:700,color:'#111827',marginBottom:20 }}>Booking Status</div>
          {Object.entries(BSTATUS).map(([k,s])=>{ const n=bookings.filter(b=>b.status===k).length; const pct=bookings.length>0?Math.round(n/bookings.length*100):0; return (
            <div key={k} style={{ marginBottom:14 }}><div style={{ display:'flex',justifyContent:'space-between',marginBottom:5 }}><span style={{ fontSize:12,fontWeight:600,color:'#374151',textTransform:'capitalize' }}>{k}</span><span style={{ fontSize:12,fontWeight:700,color:'#111827' }}>{n} <span style={{ color:'#9CA3AF',fontWeight:400 }}>({pct}%)</span></span></div><div style={{ background:'#F3F4F6',borderRadius:99,height:8,overflow:'hidden' }}><div style={{ width:`${pct}%`,height:'100%',background:s.color,borderRadius:99,transition:'width 0.6s' }}/></div></div>
          );})}
        </div>
        <div style={{ background:'#fff',borderRadius:14,border:'1px solid #F3F4F6',padding:24,boxShadow:'0 1px 4px rgba(0,0,0,0.04)',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center' }}>
          <div style={{ fontSize:15,fontWeight:700,color:'#111827',marginBottom:20,alignSelf:'flex-start' }}>Fleet Utilization</div>
          <div style={{ position:'relative',width:150,height:150,marginBottom:16 }}>
            <svg viewBox="0 0 36 36" style={{ width:150,height:150,transform:'rotate(-90deg)' }}>
              <circle cx="18" cy="18" r="15.9" fill="none" stroke="#F3F4F6" strokeWidth="3.8"/>
              <circle cx="18" cy="18" r="15.9" fill="none" stroke="#C41230" strokeWidth="3.8" strokeDasharray={`${fleetUtil} 100`} strokeLinecap="round"/>
            </svg>
            <div style={{ position:'absolute',inset:0,display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center' }}>
              <div style={{ fontFamily:'var(--font-display)',fontSize:32,color:'#111827',letterSpacing:'0.04em',lineHeight:1 }}>{fleetUtil}%</div>
              <div style={{ fontSize:11,color:'#9CA3AF',fontWeight:700,marginTop:2 }}>ON RENT</div>
            </div>
          </div>
          <div style={{ display:'flex',gap:20 }}>
            <div style={{ display:'flex',alignItems:'center',gap:6,fontSize:12,color:'#374151' }}><div style={{ width:10,height:10,borderRadius:2,background:'#C41230' }}/>On Rent ({vehicles.filter(v=>v.status==='on_rent').length})</div>
            <div style={{ display:'flex',alignItems:'center',gap:6,fontSize:12,color:'#374151' }}><div style={{ width:10,height:10,borderRadius:2,background:'#F3F4F6',border:'1px solid #E5E7EB' }}/>Other ({vehicles.length-vehicles.filter(v=>v.status==='on_rent').length})</div>
          </div>
        </div>
      </div>
    </div>
  );
}

// ══════════════════════════════════════════════════════
// CALENDAR HELPERS  (all outside any component)
// ══════════════════════════════════════════════════════
const CAL_KEY = 'r355_calendar_v1';

const SRC_COLORS = {
  website:   { bg:'#DBEAFE', color:'#1D4ED8', border:'#93C5FD', label:'Website'   },
  agency:    { bg:'#EDE9FE', color:'#6D28D9', border:'#C4B5FD', label:'Agency'    },
  walkin:    { bg:'#DCFCE7', color:'#15803D', border:'#86EFAC', label:'Walk-in'   },
  phone:     { bg:'#FEF3C7', color:'#B45309', border:'#FCD34D', label:'Phone'     },
  returning: { bg:'#FEE2E2', color:'#B91C1C', border:'#FCA5A5', label:'Returning' },
  other:     { bg:'#F3F4F6', color:'#374151', border:'#D1D5DB', label:'Other'     },
};
const srcColor = src => SRC_COLORS[src] || SRC_COLORS.other;

const CAL_PAY = {
  paid:       { label:'Paid',        color:'#059669', bg:'#DCFCE7' },
  partial:    { label:'Partial',     color:'#D97706', bg:'#FEF3C7' },
  unpaid:     { label:'Unpaid',      color:'#DC2626', bg:'#FEE2E2' },
  agency_inv: { label:'Agency Inv.', color:'#6D28D9', bg:'#EDE9FE' },
};

function isoToMidnight(s) { return s ? new Date(s + 'T00:00:00') : null; }
function dateToIso(d) { const y=d.getFullYear(), m=String(d.getMonth()+1).padStart(2,'0'), day=String(d.getDate()).padStart(2,'0'); return `${y}-${m}-${day}`; }
function rentalSpansDay(r, iso) { return !!r.startDate && !!r.endDate && r.startDate <= iso && r.endDate >= iso; }
function rentalDays(r) {
  if (!r.startDate || !r.endDate) return 0;
  return Math.max(1, Math.ceil((isoToMidnight(r.endDate) - isoToMidnight(r.startDate)) / 86400000) + 1);
}

// Stable field components — defined once at module level, NEVER inside another component
function CalInput({ label, value, onChange, type, placeholder, required, span }) {
  const focStyle = e => { e.target.style.borderColor='#C41230'; e.target.style.background='#fff'; };
  const blrStyle = e => { e.target.style.borderColor='#E5E7EB'; e.target.style.background='#F9FAFB'; };
  return (
    <div style={{ gridColumn: span===2 ? 'span 2' : 'auto' }}>
      <label style={lbl}>{label}{required && <span style={{color:'#C41230'}}> *</span>}</label>
      <input
        type={type||'text'}
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder||''}
        style={{ ...inp, background:'#F9FAFB' }}
        onFocus={focStyle}
        onBlur={blrStyle}
      />
    </div>
  );
}

function CalSelect({ label, value, onChange, options, span, required }) {
  const focStyle = e => { e.target.style.borderColor='#C41230'; e.target.style.background='#fff'; };
  const blrStyle = e => { e.target.style.borderColor='#E5E7EB'; e.target.style.background='#F9FAFB'; };
  return (
    <div style={{ gridColumn: span===2 ? 'span 2' : 'auto' }}>
      <label style={lbl}>{label}{required && <span style={{color:'#C41230'}}> *</span>}</label>
      <select
        value={value}
        onChange={e => onChange(e.target.value)}
        style={{ ...inp, background:'#F9FAFB' }}
        onFocus={focStyle}
        onBlur={blrStyle}
      >
        <option value="">— Select —</option>
        {options.map(([v,l]) => <option key={v} value={v}>{l}</option>)}
      </select>
    </div>
  );
}

function CalTextarea({ label, value, onChange, placeholder }) {
  const focStyle = e => { e.target.style.borderColor='#C41230'; e.target.style.background='#fff'; };
  const blrStyle = e => { e.target.style.borderColor='#E5E7EB'; e.target.style.background='#F9FAFB'; };
  return (
    <div>
      <label style={lbl}>{label}</label>
      <textarea
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder||''}
        style={{ ...inp, minHeight:80, resize:'vertical', background:'#F9FAFB' }}
        onFocus={focStyle}
        onBlur={blrStyle}
      />
    </div>
  );
}

function CalSectionTitle({ children }) {
  return (
    <div style={{ fontSize:11, fontWeight:700, color:'#9CA3AF', textTransform:'uppercase', letterSpacing:'0.08em', marginBottom:12, marginTop:4 }}>
      {children}
    </div>
  );
}

// ══════════════════════════════════════════════════════
// RENTAL MODAL
// ══════════════════════════════════════════════════════
function RentalModal({ rental, vehicles, onSave, onDelete, onClose }) {
  const isNew = !rental.id;
  const [clientName,       setClientName]       = useState(rental.clientName       || '');
  const [clientPhone,      setClientPhone]      = useState(rental.clientPhone      || '');
  const [clientEmail,      setClientEmail]      = useState(rental.clientEmail      || '');
  const [clientId,         setClientId]         = useState(rental.clientId         || '');
  const [carId,            setCarId]            = useState(String(rental.carId     || ''));
  const [startDate,        setStartDate]        = useState(rental.startDate        || '');
  const [endDate,          setEndDate]          = useState(rental.endDate          || '');
  const [source,           setSource]           = useState(rental.source           || 'walkin');
  const [agency,           setAgency]           = useState(rental.agency           || '');
  const [agentName,        setAgentName]        = useState(rental.agentName        || '');
  const [agencyCommission, setAgencyCommission] = useState(rental.agencyCommission || '');
  const [agencyRef,        setAgencyRef]        = useState(rental.agencyRef        || '');
  const [totalPrice,       setTotalPrice]       = useState(String(rental.totalPrice|| ''));
  const [depositPaid,      setDepositPaid]      = useState(String(rental.depositPaid||''));
  const [payStatus,        setPayStatus]        = useState(rental.payStatus        || 'unpaid');
  const [payMethod,        setPayMethod]        = useState(rental.payMethod        || 'cash');
  const [notes,            setNotes]            = useState(rental.notes            || '');
  const [internalNotes,    setInternalNotes]    = useState(rental.internalNotes    || '');
  const [extras,           setExtras]           = useState(rental.extras || []);
  const [extraLabel,       setExtraLabel]       = useState('');
  const [extraPrice,       setExtraPrice]       = useState('');

  const PRESET_EXTRAS = ['Full Insurance','Airport Pickup','Hotel Pickup','Child Seat','GPS','Extra Driver','Baby Seat','Ski Rack','Roof Box'];
  const addExtra = (label, price='') => {
    if (!label.trim()) return;
    setExtras(ex => [...ex, { id: Date.now(), label, price: Number(price)||0 }]);
    setExtraLabel(''); setExtraPrice('');
  };
  const removeExtra = id => setExtras(ex => ex.filter(e => e.id !== id));
  const extrasTotal = extras.reduce((s,e) => s + (Number(e.price)||0), 0);

  const calcDoneRef = React.useRef(false);
  useEffect(() => {
    if (calcDoneRef.current || totalPrice || !carId || !startDate || !endDate) return;
    const car = vehicles.find(v => String(v.id) === carId);
    if (car) {
      const d = Math.max(1, Math.ceil((isoToMidnight(endDate) - isoToMidnight(startDate)) / 86400000) + 1);
      setTotalPrice(String(d * car.price));
      calcDoneRef.current = true;
    }
  }, [carId, startDate, endDate]);

  const days = startDate && endDate
    ? Math.max(1, Math.ceil((isoToMidnight(endDate) - isoToMidnight(startDate)) / 86400000) + 1)
    : 0;
  const selectedCar = vehicles.find(v => String(v.id) === carId);

  const handleSave = () => {
    if (!clientName.trim()) { alert('Client name is required'); return; }
    if (!startDate || !endDate) { alert('Dates are required'); return; }
    if (endDate < startDate) { alert('Return date must be after pickup date'); return; }
    onSave({ id:rental.id, clientName, clientPhone, clientEmail, clientId,
      carId, startDate, endDate, source, agency, agentName, agencyCommission, agencyRef,
      totalPrice, depositPaid, payStatus, payMethod, notes, internalNotes, extras });
  };

  return (
    <Modal onClose={onClose} wide>
      <div style={{padding:'20px 26px',borderBottom:'1px solid #F3F4F6',display:'flex',justifyContent:'space-between',alignItems:'center',flexShrink:0}}>
        <div style={{fontSize:17,fontWeight:700,color:'#111827'}}>{isNew ? '➕ New Rental' : `✏️ Edit: ${rental.clientName||'Rental'}`}</div>
        <button onClick={onClose} style={{background:'none',border:'none',cursor:'pointer',color:'#9CA3AF',padding:4}}><Ic d={I.close} size={18}/></button>
      </div>

      <div style={{padding:'20px 26px',overflowY:'auto',flex:1}}>

        <CalSectionTitle>Client Info</CalSectionTitle>
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:14,marginBottom:22}}>
          <CalInput label="Client Name"       value={clientName}  onChange={setClientName}  placeholder="e.g. Edi Rama" required/>
          <CalInput label="Phone"             value={clientPhone} onChange={setClientPhone} placeholder="+355 69 ..."/>
          <CalInput label="Email"             value={clientEmail} onChange={setClientEmail} type="email" placeholder="client@email.com"/>
          <CalInput label="ID / Passport No." value={clientId}    onChange={setClientId}    placeholder="e.g. A12345678"/>
        </div>

        <CalSectionTitle>Rental Details</CalSectionTitle>
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:14,marginBottom:22}}>
          <div>
            <label style={lbl}>Vehicle <span style={{color:'#C41230'}}>*</span></label>
            <select value={carId} onChange={e=>setCarId(e.target.value)}
              style={{...inp,background:'#F9FAFB'}}
              onFocus={e=>{e.target.style.borderColor='#C41230';e.target.style.background='#fff';}}
              onBlur={e=>{e.target.style.borderColor='#E5E7EB';e.target.style.background='#F9FAFB';}}>
              <option value="">— Select vehicle —</option>
              {vehicles.map(v => {
                const plate = LS.get('r355_fleet_extra',{})[v.id]?.plate || '';
                return <option key={v.id} value={String(v.id)}>{v.name}{plate ? ` [${plate}]` : ''} · €{v.price}/day</option>;
              })}
            </select>
          </div>
          <CalSelect label="Source" value={source} onChange={setSource} options={[
            ['walkin','🚶 Walk-in'],['website','🌐 Website'],['agency','🤝 Agency'],
            ['phone','📞 Phone Call'],['returning','🔄 Returning Client'],['other','Other'],
          ]}/>
          <CalInput label="Pickup Date" value={startDate} onChange={setStartDate} type="date" required/>
          <CalInput label="Return Date" value={endDate}   onChange={setEndDate}   type="date" required/>
          {days > 0 && (
            <div style={{gridColumn:'span 2',background:'#F0FDF4',border:'1px solid #86EFAC',borderRadius:9,padding:'10px 14px',fontSize:13,fontWeight:600,color:'#15803D',display:'flex',justifyContent:'space-between'}}>
              <span>📅 {days} day{days!==1?'s':''}</span>
              {selectedCar && <span>Suggested: €{days * selectedCar.price}</span>}
            </div>
          )}
        </div>

        {source === 'agency' && <>
          <CalSectionTitle>Agency Details</CalSectionTitle>
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:14,marginBottom:22}}>
            <CalInput label="Agency Name"    value={agency}           onChange={setAgency}           placeholder="e.g. Tirana Tours"/>
            <CalInput label="Agent Name"     value={agentName}        onChange={setAgentName}        placeholder="e.g. Arben Hoxha"/>
            <CalInput label="Commission (€)" value={agencyCommission} onChange={setAgencyCommission} type="number" placeholder="e.g. 20"/>
            <CalInput label="Agency Ref."    value={agencyRef}        onChange={setAgencyRef}        placeholder="e.g. TT-2026-041"/>
          </div>
        </>}

        <CalSectionTitle>Payment</CalSectionTitle>
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:14,marginBottom:22}}>
          <CalInput  label="Total Price (€)"  value={totalPrice}  onChange={setTotalPrice}  type="number" placeholder="Auto-calculated"/>
          <CalInput  label="Deposit Paid (€)" value={depositPaid} onChange={setDepositPaid} type="number" placeholder="e.g. 50"/>
          <CalSelect label="Payment Status" value={payStatus} onChange={setPayStatus} options={[
            ['paid','✅ Paid in Full'],['partial','⚠️ Partial / Deposit'],
            ['unpaid','❌ Unpaid'],['agency_inv','📄 Agency Invoice'],
          ]}/>
          <CalSelect label="Payment Method" value={payMethod} onChange={setPayMethod} options={[
            ['cash','💵 Cash'],['bank','🏦 Bank Transfer'],
            ['card','💳 Card'],['agency','🤝 Via Agency'],
          ]}/>
        </div>

        <CalSectionTitle>Extras & Add-ons</CalSectionTitle>
        <div style={{marginBottom:22}}>
          {/* Preset buttons */}
          <div style={{display:'flex',flexWrap:'wrap',gap:7,marginBottom:12}}>
            {PRESET_EXTRAS.map(p => (
              <button key={p} onClick={()=>addExtra(p)}
                style={{background:extras.some(e=>e.label===p)?'#FEF0F2':'#F3F4F6',border:`1px solid ${extras.some(e=>e.label===p)?'#C41230':'#E5E7EB'}`,borderRadius:20,padding:'5px 13px',fontSize:12,fontWeight:600,color:extras.some(e=>e.label===p)?'#C41230':'#374151',cursor:'pointer',fontFamily:'var(--font-body)',transition:'all 0.15s'}}>
                {p}
              </button>
            ))}
          </div>
          {/* Custom extra */}
          <div style={{display:'flex',gap:8,alignItems:'flex-end',marginBottom:12}}>
            <div style={{flex:1}}>
              <label style={lbl}>Custom Item</label>
              <input value={extraLabel} onChange={e=>setExtraLabel(e.target.value)} placeholder="e.g. Delivery to hotel"
                style={{...inp,background:'#F9FAFB'}} onKeyDown={e=>e.key==='Enter'&&addExtra(extraLabel,extraPrice)}/>
            </div>
            <div style={{width:110}}>
              <label style={lbl}>Price (€)</label>
              <input value={extraPrice} onChange={e=>setExtraPrice(e.target.value)} placeholder="0" type="number"
                style={{...inp,background:'#F9FAFB'}} onKeyDown={e=>e.key==='Enter'&&addExtra(extraLabel,extraPrice)}/>
            </div>
            <button onClick={()=>addExtra(extraLabel,extraPrice)}
              style={{background:'var(--red)',color:'#fff',border:'none',borderRadius:9,padding:'9px 16px',fontSize:13,fontWeight:700,cursor:'pointer',fontFamily:'var(--font-body)',marginBottom:1}}>
              + Add
            </button>
          </div>
          {/* Added extras list */}
          {extras.length > 0 && (
            <div style={{background:'#F9FAFB',borderRadius:10,border:'1px solid #F3F4F6',overflow:'hidden'}}>
              {extras.map(e => (
                <div key={e.id} style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'9px 14px',borderBottom:'1px solid #F3F4F6'}}>
                  <div style={{fontSize:13,fontWeight:600,color:'#111827'}}>{e.label}</div>
                  <div style={{display:'flex',alignItems:'center',gap:12}}>
                    <input value={e.price} onChange={ev=>setExtras(ex=>ex.map(x=>x.id===e.id?{...x,price:Number(ev.target.value)||0}:x))}
                      style={{width:70,padding:'4px 8px',border:'1px solid #E5E7EB',borderRadius:6,fontSize:12,fontFamily:'var(--font-body)',textAlign:'right'}} type="number"/>
                    <span style={{fontSize:13,fontWeight:700,color:'var(--red)',minWidth:40,textAlign:'right'}}>€{e.price||0}</span>
                    <button onClick={()=>removeExtra(e.id)} style={{background:'none',border:'none',cursor:'pointer',color:'#9CA3AF',padding:2,fontSize:16,lineHeight:1}}>✕</button>
                  </div>
                </div>
              ))}
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'10px 14px',background:'#fff',borderTop:'2px solid #F3F4F6'}}>
                <div style={{fontSize:12,fontWeight:700,color:'#6B7280',textTransform:'uppercase',letterSpacing:'0.05em'}}>Extras Total</div>
                <div style={{fontSize:15,fontWeight:700,color:'var(--red)',fontFamily:'var(--font-display)'}}>€{extrasTotal}</div>
              </div>
            </div>
          )}
        </div>

        <CalSectionTitle>Notes</CalSectionTitle>
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:14}}>
          <CalTextarea label="Notes"          value={notes}         onChange={setNotes}         placeholder="Pickup location, special requests…"/>
          <CalTextarea label="Internal Notes" value={internalNotes} onChange={setInternalNotes} placeholder="Private reminders, damage notes…"/>
        </div>

      </div>

      <div style={{padding:'16px 26px',borderTop:'1px solid #F3F4F6',display:'flex',justifyContent:'space-between',alignItems:'center',flexShrink:0}}>
        <div>
          {!isNew && <GhostBtn onClick={()=>onDelete(rental.id)} style={{color:'#DC2626',borderColor:'#FCA5A5'}}><Ic d={I.trash} size={13}/> Delete</GhostBtn>}
        </div>
        <div style={{display:'flex',gap:10}}>
          <GhostBtn onClick={onClose}>Cancel</GhostBtn>
          <PrimaryBtn onClick={handleSave}>{isNew ? 'Add Rental' : 'Save Changes'}</PrimaryBtn>
        </div>
      </div>
    </Modal>
  );
}

// ══════════════════════════════════════════════════════
// CALENDAR SUB-VIEWS
// ══════════════════════════════════════════════════════
function CalMonthView({ rentals, curDate, onDayClick, onRentalClick }) {
  const year = curDate.getFullYear(), month = curDate.getMonth();
  const firstDay = new Date(year, month, 1);
  const lastDay  = new Date(year, month + 1, 0);
  const days = [];
  for (let i = 0; i < firstDay.getDay(); i++) days.push(null);
  for (let d = 1; d <= lastDay.getDate(); d++) days.push(new Date(year, month, d));
  const todayIso = dateToIso(new Date());
  return (
    <div>
      <div style={{display:'grid',gridTemplateColumns:'repeat(7,1fr)',gap:2,marginBottom:2}}>
        {['Sun','Mon','Tue','Wed','Thu','Fri','Sat'].map(d=>(
          <div key={d} style={{textAlign:'center',fontSize:11,fontWeight:700,color:'#9CA3AF',padding:'8px 0',letterSpacing:'0.06em',textTransform:'uppercase'}}>{d}</div>
        ))}
      </div>
      <div style={{display:'grid',gridTemplateColumns:'repeat(7,1fr)',gap:2}}>
        {days.map((day,i)=>{
          if(!day) return <div key={`e${i}`} style={{minHeight:110,background:'#FAFAFA',borderRadius:8}}/>;
          const iso=dateToIso(day);
          const dr=rentals.filter(r=>rentalSpansDay(r,iso));
          const isToday=iso===todayIso;
          return (
            <div key={iso} onClick={()=>onDayClick(iso)}
              style={{minHeight:110,background:'#fff',borderRadius:8,border:`1.5px solid ${isToday?'#C41230':'#F3F4F6'}`,padding:'6px',overflow:'hidden',cursor:'pointer'}}
              onMouseEnter={e=>e.currentTarget.style.boxShadow='0 4px 12px rgba(0,0,0,0.08)'}
              onMouseLeave={e=>e.currentTarget.style.boxShadow='none'}>
              <div style={{fontSize:11,marginBottom:4,display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                <span style={{background:isToday?'#C41230':'transparent',color:isToday?'#fff':'#374151',borderRadius:'50%',width:22,height:22,display:'flex',alignItems:'center',justifyContent:'center',fontWeight:isToday?800:600}}>{day.getDate()}</span>
                {dr.length>0&&<span style={{fontSize:10,fontWeight:700,color:'#9CA3AF'}}>{dr.length}</span>}
              </div>
              {dr.slice(0,3).map(r=>{
                const sc=srcColor(r.source);
                return <div key={r.id} onClick={e=>{e.stopPropagation();onRentalClick(r);}}
                  style={{background:sc.bg,color:sc.color,borderLeft:`3px solid ${sc.border}`,borderRadius:4,padding:'3px 6px',marginBottom:3,fontSize:10,fontWeight:600,overflow:'hidden',whiteSpace:'nowrap',textOverflow:'ellipsis',cursor:'pointer'}}>
                  {r.startDate===iso?'▶ ':''}{r.clientName}
                </div>;
              })}
              {dr.length>3&&<div style={{fontSize:10,color:'#9CA3AF',fontWeight:600}}>+{dr.length-3} more</div>}
            </div>
          );
        })}
      </div>
    </div>
  );
}

function CalGanttView({ rentals, vehicles, curDate, onCellClick, onRentalClick }) {
  const startOfWeek = new Date(curDate);
  startOfWeek.setDate(startOfWeek.getDate()-startOfWeek.getDay());
  const days=Array.from({length:7},(_,i)=>{ const d=new Date(startOfWeek); d.setDate(d.getDate()+i); return d; });
  const todayIso=dateToIso(new Date());
  return (
    <div style={{overflowX:'auto'}}>
      <table style={{width:'100%',borderCollapse:'collapse',minWidth:700}}>
        <thead><tr style={{background:'#F9FAFB'}}>
          <th style={{width:160,padding:'10px 14px',textAlign:'left',fontSize:11,fontWeight:700,color:'#9CA3AF',letterSpacing:'0.07em',textTransform:'uppercase',borderBottom:'2px solid #F3F4F6',position:'sticky',left:0,background:'#F9FAFB',zIndex:2}}>Vehicle</th>
          {days.map(d=>{
            const iso=dateToIso(d), isToday=iso===todayIso;
            return <th key={iso} style={{padding:'10px 6px',textAlign:'center',fontSize:11,fontWeight:700,color:isToday?'#C41230':'#6B7280',borderBottom:'2px solid #F3F4F6',background:isToday?'#FFF5F6':'#F9FAFB',minWidth:90}}>
              <div>{['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][d.getDay()]}</div>
              <div style={{fontSize:15,fontWeight:800,marginTop:1}}>{d.getDate()}</div>
              <div style={{fontSize:9,color:'#9CA3AF'}}>{d.toLocaleString('default',{month:'short'})}</div>
            </th>;
          })}
        </tr></thead>
        <tbody>
          {vehicles.map(car=>{
            const extra=LS.get('r355_fleet_extra',{})[car.id]||{};
            return <tr key={car.id} style={{borderBottom:'1px solid #F9FAFB'}}>
              <td style={{padding:'10px 14px',position:'sticky',left:0,background:'#fff',zIndex:1,borderRight:'2px solid #F3F4F6'}}>
                <div style={{display:'flex',alignItems:'center',gap:8}}>
                  {car.image?<img src={car.image} alt="" style={{width:36,height:24,objectFit:'cover',borderRadius:4,flexShrink:0}}/>
                    :<div style={{width:36,height:24,background:'#F3F4F6',borderRadius:4,flexShrink:0}}/>}
                  <div>
                    <div style={{fontSize:12,fontWeight:700,color:'#111827',whiteSpace:'nowrap'}}>{car.name}</div>
                    {extra.plate&&<div style={{fontSize:10,color:'#9CA3AF',fontFamily:'monospace'}}>{extra.plate}</div>}
                  </div>
                </div>
              </td>
              {days.map(day=>{
                const iso=dateToIso(day), isToday=iso===todayIso;
                const dr=rentals.filter(r=>String(r.carId)===String(car.id)&&rentalSpansDay(r,iso));
                return <td key={iso} style={{padding:'4px',verticalAlign:'top',background:isToday?'#FFFAFA':'#fff',borderRight:'1px solid #F9FAFB',cursor:'pointer',minHeight:44}}
                  onClick={()=>onCellClick(iso,car.id)}>
                  {dr.map(r=>{
                    const sc=srcColor(r.source);
                    return <div key={r.id} onClick={e=>{e.stopPropagation();onRentalClick(r);}}
                      style={{background:sc.bg,color:sc.color,border:`1.5px solid ${sc.border}`,borderRadius:5,padding:'4px 7px',marginBottom:2,fontSize:10,fontWeight:700,cursor:'pointer',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>
                      {r.startDate===iso?'▶ ':''}{r.clientName}
                    </div>;
                  })}
                </td>;
              })}
            </tr>;
          })}
          {vehicles.length===0&&<tr><td colSpan={8} style={{padding:40,textAlign:'center',color:'#CBD5E1',fontSize:13}}>No vehicles yet.</td></tr>}
        </tbody>
      </table>
    </div>
  );
}

function CalListView({ rentals, vehicles, onEdit }) {
  const todayIso=dateToIso(new Date());
  const sorted=[...rentals].sort((a,b)=>(a.startDate||'').localeCompare(b.startDate||''));
  const upcoming=sorted.filter(r=>r.endDate>=todayIso);
  const past=sorted.filter(r=>r.endDate<todayIso);
  const HEADS=['Client','Vehicle','Dates','Source','Agency','Total','Payment','Notes'];
  const Row=({r})=>{
    const car=vehicles.find(v=>String(v.id)===String(r.carId));
    const extra=LS.get('r355_fleet_extra',{})[r.carId]||{};
    const sc=srcColor(r.source), ps=CAL_PAY[r.payStatus]||CAL_PAY.unpaid, d=rentalDays(r);
    return <tr onClick={()=>onEdit(r)} style={{borderBottom:'1px solid #F9FAFB',cursor:'pointer'}}
      onMouseEnter={e=>e.currentTarget.style.background='#F9FAFB'}
      onMouseLeave={e=>e.currentTarget.style.background=''}>
      <td style={{padding:'12px 16px'}}><div style={{fontWeight:700,fontSize:13,color:'#111827'}}>{r.clientName}</div><div style={{fontSize:11,color:'#9CA3AF'}}>{r.clientPhone}</div></td>
      <td style={{padding:'12px 16px',fontSize:12}}>{car?<div><div style={{fontWeight:600,color:'#111827'}}>{car.name}</div>{extra.plate&&<span style={{fontSize:10,color:'#9CA3AF',fontFamily:'monospace'}}>{extra.plate}</span>}</div>:<span style={{color:'#CBD5E1'}}>—</span>}</td>
      <td style={{padding:'12px 16px',fontSize:12,color:'#6B7280',whiteSpace:'nowrap'}}>{r.startDate} → {r.endDate}<div style={{fontSize:10,color:'#9CA3AF'}}>{d} day{d!==1?'s':''}</div></td>
      <td style={{padding:'12px 16px'}}><span style={{background:sc.bg,color:sc.color,border:`1px solid ${sc.border}`,borderRadius:20,padding:'3px 10px',fontSize:11,fontWeight:700}}>{sc.label}</span></td>
      <td style={{padding:'12px 16px',fontSize:12}}>{r.agency?<div><div style={{fontWeight:600,color:'#6D28D9'}}>{r.agency}</div>{r.agencyCommission&&<div style={{fontSize:11,color:'#9CA3AF'}}>€{r.agencyCommission}</div>}</div>:<span style={{color:'#CBD5E1'}}>—</span>}</td>
      <td style={{padding:'12px 16px'}}><div style={{fontFamily:'var(--font-display)',fontSize:20,color:'var(--red)',letterSpacing:'0.03em'}}>€{r.totalPrice||0}</div>{r.depositPaid&&<div style={{fontSize:10,color:'#059669',fontWeight:700}}>Dep:€{r.depositPaid}</div>}</td>
      <td style={{padding:'12px 16px'}}><span style={{background:ps.bg,color:ps.color,borderRadius:20,padding:'3px 10px',fontSize:11,fontWeight:700}}>{ps.label}</span></td>
      <td style={{padding:'12px 16px',fontSize:11,color:'#6B7280',maxWidth:140,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{r.notes||'—'}</td>
    </tr>;
  };
  const Tbl=({rows})=><div style={{background:'#fff',borderRadius:12,border:'1px solid #F3F4F6',overflow:'hidden'}}>
    <table style={{width:'100%',borderCollapse:'collapse'}}>
      <thead><tr style={{background:'#F9FAFB',borderBottom:'1px solid #F3F4F6'}}>{HEADS.map(h=><th key={h} style={{padding:'10px 16px',textAlign:'left',fontSize:10,fontWeight:700,color:'#9CA3AF',letterSpacing:'0.07em',textTransform:'uppercase',whiteSpace:'nowrap'}}>{h}</th>)}</tr></thead>
      <tbody>{rows.map(r=><Row key={r.id} r={r}/>)}</tbody>
    </table>
  </div>;
  return <div>
    {upcoming.length>0&&<div style={{marginBottom:24}}><div style={{fontSize:13,fontWeight:700,color:'#374151',marginBottom:10,display:'flex',gap:8,alignItems:'center'}}><span style={{background:'#DCFCE7',color:'#059669',borderRadius:20,padding:'3px 10px',fontSize:11}}>Active & Upcoming</span><span style={{color:'#9CA3AF'}}>{upcoming.length}</span></div><Tbl rows={upcoming}/></div>}
    {past.length>0&&<div><div style={{fontSize:13,fontWeight:700,color:'#374151',marginBottom:10,display:'flex',gap:8,alignItems:'center'}}><span style={{background:'#F3F4F6',color:'#6B7280',borderRadius:20,padding:'3px 10px',fontSize:11}}>Past</span><span style={{color:'#9CA3AF'}}>{past.length}</span></div><Tbl rows={past}/></div>}
    {rentals.length===0&&<div style={{padding:60,textAlign:'center',color:'#CBD5E1',fontSize:13}}>No rentals yet. Click "+ Add Rental" or any day to start.</div>}
  </div>;
}

// ══════════════════════════════════════════════════════
// CALENDAR VIEW
// ══════════════════════════════════════════════════════
function CalendarView({ showToast }) {
  const [rentals,   setRentals]   = useState(()=>LS.get(CAL_KEY,[]));
  const [vehicles,  setVehicles]  = useState([]);
  const [modal,     setModal]     = useState(null);
  const [calView,   setCalView]   = useState('month');
  const [curDate,   setCurDate]   = useState(new Date());
  const [filterCar, setFilterCar] = useState('all');
  const [filterSrc, setFilterSrc] = useState('all');

  useEffect(()=>{ loadFleet().then(setVehicles).catch(()=>{}); },[]);

  const persist = r => { setRentals(r); LS.set(CAL_KEY,r); };
  const saveRental = r => {
    if(r.id) persist(rentals.map(x=>x.id===r.id?r:x));
    else persist([...rentals,{...r,id:Date.now()}]);
    setModal(null);
    showToast(r.id?'Rental updated ✅':'Rental added ✅');
  };
  const deleteRental = id => {
    if(!window.confirm('Delete this rental?'))return;
    persist(rentals.filter(r=>r.id!==id));
    setModal(null);
  };

  const filtered = rentals.filter(r=>
    (filterCar==='all'||String(r.carId)===String(filterCar))&&
    (filterSrc==='all'||r.source===filterSrc)
  );

  const todayIso=dateToIso(new Date());
  const activeNow=rentals.filter(r=>r.startDate<=todayIso&&r.endDate>=todayIso).length;
  const thisMo=rentals.filter(r=>r.startDate&&r.startDate.slice(0,7)===todayIso.slice(0,7));
  const monthRev=thisMo.reduce((s,r)=>s+(Number(r.totalPrice)||0),0);
  const unpaid=rentals.filter(r=>r.payStatus==='unpaid'||r.payStatus==='partial').length;

  const navPrev=()=>{ const d=new Date(curDate); if(calView==='week')d.setDate(d.getDate()-7); else d.setMonth(d.getMonth()-1); setCurDate(d); };
  const navNext=()=>{ const d=new Date(curDate); if(calView==='week')d.setDate(d.getDate()+7); else d.setMonth(d.getMonth()+1); setCurDate(d); };
  const monthName=curDate.toLocaleString('default',{month:'long',year:'numeric'});

  return (
    <div>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:20,flexWrap:'wrap',gap:12}}>
        <div>
          <div style={{fontFamily:'var(--font-display)',fontSize:32,letterSpacing:'0.04em',color:'#111827',lineHeight:1}}>Rental Calendar</div>
          <div style={{fontSize:13,color:'#9CA3AF',marginTop:3}}>All rentals — website, agencies, walk-ins, phone</div>
        </div>
        <PrimaryBtn onClick={()=>setModal({startDate:todayIso,endDate:todayIso})}><Ic d={I.plus} size={14}/> Add Rental</PrimaryBtn>
      </div>

      <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:12,marginBottom:20}}>
        {[{label:'Active Now',value:activeNow,color:'#059669'},{label:'This Month',value:thisMo.length,color:'#2563EB'},{label:'Month Revenue',value:`€${monthRev.toLocaleString()}`,color:'#C41230'},{label:'Unpaid / Partial',value:unpaid,color:'#D97706'}].map((k,i)=>(
          <div key={i} style={{background:'#fff',borderRadius:12,padding:'16px 18px',border:'1px solid #F3F4F6',boxShadow:'0 1px 4px rgba(0,0,0,0.04)'}}>
            <div style={{fontFamily:'var(--font-display)',fontSize:28,color:k.color,letterSpacing:'0.03em',lineHeight:1}}>{k.value}</div>
            <div style={{fontSize:11,fontWeight:700,color:'#9CA3AF',textTransform:'uppercase',letterSpacing:'0.06em',marginTop:4}}>{k.label}</div>
          </div>
        ))}
      </div>

      <div style={{background:'#fff',borderRadius:12,border:'1px solid #F3F4F6',padding:'12px 16px',marginBottom:16,display:'flex',alignItems:'center',gap:10,flexWrap:'wrap'}}>
        <div style={{display:'flex',alignItems:'center',gap:6}}>
          <button onClick={navPrev} style={{width:30,height:30,borderRadius:7,border:'1.5px solid #E5E7EB',background:'#fff',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',color:'#374151',fontSize:16,fontWeight:700,fontFamily:'var(--font-body)'}}>‹</button>
          <div style={{fontSize:14,fontWeight:700,color:'#111827',minWidth:180,textAlign:'center'}}>{calView==='week'?`Week of ${curDate.toLocaleDateString('en-GB',{day:'numeric',month:'short',year:'numeric'})}`:monthName}</div>
          <button onClick={navNext} style={{width:30,height:30,borderRadius:7,border:'1.5px solid #E5E7EB',background:'#fff',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',color:'#374151',fontSize:16,fontWeight:700,fontFamily:'var(--font-body)'}}>›</button>
          <button onClick={()=>setCurDate(new Date())} style={{padding:'5px 12px',borderRadius:7,border:'1.5px solid #E5E7EB',background:'#fff',cursor:'pointer',fontSize:11,fontWeight:600,color:'#374151',fontFamily:'var(--font-body)'}}>Today</button>
        </div>
        <div style={{flex:1}}/>
        <div style={{display:'flex',background:'#F3F4F6',borderRadius:8,padding:3,gap:2}}>
          {[['month','Month'],['week','Week'],['list','List']].map(([k,l])=>(
            <button key={k} onClick={()=>setCalView(k)} style={{padding:'5px 14px',borderRadius:6,border:'none',background:calView===k?'#fff':'transparent',color:calView===k?'#111827':'#9CA3AF',fontSize:12,fontWeight:calView===k?700:500,cursor:'pointer',fontFamily:'var(--font-body)',boxShadow:calView===k?'0 1px 4px rgba(0,0,0,0.08)':'none'}}>{l}</button>
          ))}
        </div>
        <select value={filterCar} onChange={e=>setFilterCar(e.target.value)} style={{...inp,width:'auto',padding:'6px 12px',fontSize:12}}>
          <option value="all">All vehicles</option>
          {vehicles.map(v=>{ const p=LS.get('r355_fleet_extra',{})[v.id]?.plate||''; return <option key={v.id} value={String(v.id)}>{v.name}{p?` [${p}]`:''}</option>; })}
        </select>
        <select value={filterSrc} onChange={e=>setFilterSrc(e.target.value)} style={{...inp,width:'auto',padding:'6px 12px',fontSize:12}}>
          <option value="all">All sources</option>
          {Object.entries(SRC_COLORS).map(([k,v])=><option key={k} value={k}>{v.label}</option>)}
        </select>
      </div>

      <div style={{display:'flex',gap:8,marginBottom:14,flexWrap:'wrap'}}>
        {Object.entries(SRC_COLORS).map(([k,c])=>(
          <span key={k} style={{background:c.bg,color:c.color,border:`1px solid ${c.border}`,borderRadius:20,padding:'3px 11px',fontSize:11,fontWeight:700}}>{c.label}</span>
        ))}
      </div>

      <div style={{background:'#fff',borderRadius:14,border:'1px solid #F3F4F6',padding:16,boxShadow:'0 1px 4px rgba(0,0,0,0.04)'}}>
        {calView==='month'&&<CalMonthView rentals={filtered} curDate={curDate} onDayClick={iso=>setModal({startDate:iso,endDate:iso})} onRentalClick={r=>setModal({...r})}/>}
        {calView==='week' &&<CalGanttView rentals={filtered} vehicles={vehicles} curDate={curDate} onCellClick={(iso,cid)=>setModal({startDate:iso,endDate:iso,carId:String(cid)})} onRentalClick={r=>setModal({...r})}/>}
        {calView==='list' &&<CalListView  rentals={filtered} vehicles={vehicles} onEdit={r=>setModal({...r})}/>}
      </div>

      {modal&&<RentalModal key={modal.id||'new'} rental={modal} vehicles={vehicles} onSave={saveRental} onDelete={deleteRental} onClose={()=>setModal(null)}/>}
    </div>
  );
}